import React, { useEffect, useState,useCallback,useRef, } from 'react';
import { useTranslation } from 'react-i18next';
import bigTournamentLongSocket, { ensureBigTournamentLongSocket } from './bigTournamentLongSocket';
import { useParams, useLocation } from 'react-router-dom';
import { notTooOften } from './utils/clientAntiSpam';
import { safeThrottle } from './utils/socketGuards';
// import bigTournamentLongSocket from './bigTournamentLongSocket';
import BigTournamentBackgammonBoardDisplay from './BigTournamentBackgammonBoardDisplay'
import { useMemo } from 'react';
import { useGame } from './context/GameContext';

const API_ORIGIN =
  process.env.REACT_APP_API_URL ||
  'http://localhost:5000';

const API_BASE = `${API_ORIGIN}/api`;
const BigTournamentBackgammon = () => {
const { t: translate } = useTranslation();
const {blockStol, setBlockStol} = useGame() 
//   const { tableId } = useParams();
  
  // Основные стейты
  const [username, setUsername] = useState('');
  const [longBoardState, setLongBoardState] = useState(() =>
  Array.from({ length: 24 }, () => [])
);

  // const [longBoard, setLongBoard] = useState([]);
  const [longWhiteOffBoard, setLongWhiteOffBoard] = useState([]);
  const [longBlackOffBoard, setLongBlackOffBoard] = useState([]);
  const [longMyColor, setLongMyColor] = useState(null);
  const [longCurrentTurn, setLongCurrentTurn] = useState(null);
  const [longDiceValues, setLongDiceValues] = useState([]);
  const [longNumberMove, setLongNumberMove] = useState(0);
  // const [longFirstRolls, setLongFirstRolls] = useState({});
  const [longFirstRolls, setLongFirstRolls] = useState({
  player1Roll: null,
  player2Roll: null,
});
 
  const [longFirstMoveComplete, setLongFirstMoveComplete] = useState([]);
  const [longFirstRollComplete, setLongFirstRollComplete] = useState(false);
  const [longRolledDice, setLongRolledDice] = useState([]);
  const [longOpponentColor, setLongOpponentColor] = useState(null);
  const [longHasRolledDice, setLongHasRolledDice] = useState(false);
  const [longRollEnabled, setLongRollEnabled] = useState('false');
  const [longUsedRolls, setLongUsedRolls] = useState([]); // Добавляем это состояние
  const [longPlayer1Name, setLongPlayer1Name] = useState('');
  const [longPlayer2Name, setLongPlayer2Name] = useState('');
  const [longDisableBoardClicks, setLongDisableBoardClicks] = useState(false);
  const [longLastMoveType, setLongLastMoveType] = useState(null); // 'click' или 'drag'
  const dataListenerAttachedRef = useRef(false);


 const [visibleOpponentTime, setVisibleOpponentTime] = useState(300);
  const intervalRef = useRef(null);
  
  // Для отката ходов
  const [longMoveHistory, setLongMoveHistory] = useState([]);
  const [longShowUndoButton, setLongShowUndoButton] = useState(false);
const pendingAutoRollRef = useRef(null);
  // Для состояния загрузки/ошибки
  const [longLoading, setLongLoading] = useState(true);
  const [longError, setLongError] = useState('');
  const [longPlayerColor, setLongPlayerColor] = useState('');
  const [headMoveCount, setHeadMoveCount] = useState(0);
const [headCheckersMoved, setHeadCheckersMoved] = useState(0)
const justConfirmedRef = useRef(false);
const headInitialCountRef = useRef(null);
const [isFinished, setIsFinished] = useState(false);


const isSpectator = false;
const [player1Time, setPlayer1Time] = useState(60);
const [player2Time, setPlayer2Time] = useState(60);
const [resignPending, setResignPending] = useState(false);
const tickRef      = useRef(null);
 const [longInitialRollPhase, setLongInitialRollPhase] = useState(false);


 // --- Состояние соединения с сокетом ---
const [isSocketConnected, setIsSocketConnected] = useState(true);
const [wasDisconnected, setWasDisconnected] = useState(false);

// нужно, чтобы понять, что после reconnection надо обновить состояние с сервера
const needResyncOnReconnectRef = useRef(false);




 const alreadyJoinedRef = useRef(false);
// аватар + рейтинг «за столом»
const [player1Profile, setPlayer1Profile] = useState({ avatar: null, rating: null });
const [player2Profile, setPlayer2Profile] = useState({ avatar: null, rating: null });


const [tournamentStageLabel, setTournamentStageLabel] = useState(null); // 'Полуфинал' | 'Финал' | null
const [tournamentPrize, setTournamentPrize] = useState(null); 


// авто-режимы (память не сохраняем — только в текущей сессии)
const [autoRoll, setAutoRoll] = useState(false);
const [autoConfirm, setAutoConfirm] = useState(false);


// ДОПОЛНИ: стейты для модального окна завершения
const [endModal, setEndModal] = useState({
  open: false,
  title: '',
  subtitle: '',
  note: '',
  isFinal: false,
  rebuyAvailable: false,
  rebuyCost: 0,
  tournamentId: null,
  rebuyError: '',
});
const [rebuyPending, setRebuyPending] = useState(false);
const endModalTimerRef = useRef(null);
const endModalOpenRef = useRef(false);



const awaitingConfirmRef = useRef(false);

// После F5 не разрешаем автоподтверждение,
// пока не получен полный снимок игры с сервера.
const gameStateHydratedRef = useRef(false);

  const location = useLocation();
  const { id: longGameId } = useParams();
  const queryParams = new URLSearchParams(location.search);
  const longTableId = queryParams.get('tableId');
  const longUsername = localStorage.getItem('username') || '';
  // ==============================
  // Подключаемся / запрашиваем игру
  // ==============================
const tableId = queryParams.get('tableId');
const safeEmit = (event, payload) => {
  if (!isFinished) {
    bigTournamentLongSocket.emit(event, payload);
  }
};

const colorResolvedRef = useRef(false);



function detectMyColor(game, myUsername) {
  if (!game?.player1_name || !game?.player2_name) return null;
  return game.player1_name === myUsername ? 'white' : 'black';
}


const isMyTurn = useMemo(() => {
  return (
    (longMyColor === 'white' && longCurrentTurn === 'player1') ||
    (longMyColor === 'black' && longCurrentTurn === 'player2')
  );
}, [longMyColor, longCurrentTurn]);


const isMyTurnRef = useRef(false);
useEffect(() => {
  isMyTurnRef.current = isMyTurn;
}, [isMyTurn]);




// Авто-бросок: мой ход, кубики ещё не брошены и бросать разрешено
useEffect(() => {
  if (isFinished) return;
  if (!autoRoll) return;
  if (!isMyTurn) return;
  if (longHasRolledDice) return;
  if (!longRollEnabled) return;

  handleLongRollDiceClick();  // бросаем автоматически
}, [autoRoll, isMyTurn, longHasRolledDice, longRollEnabled, isFinished]);

// Автоподтверждение: когда ходы закончились (или их не было)
useEffect(() => {
  if (isFinished) return;
  if (!gameStateHydratedRef.current) return;
  if (!autoConfirm) return;
  if (!isMyTurn) return;
  if (justConfirmedRef.current) return; // уже подтвердили

  const noMovesLeft = longNumberMove <= 0 || longDiceValues.length === 0;

  if (longHasRolledDice && noMovesLeft) {
    longConfirmMove({
      boardState: longBoardState,
      whiteOffBoard: longWhiteOffBoard,
      blackOffBoard: longBlackOffBoard,
    });
  }
}, [
  autoConfirm, isMyTurn, isFinished,
  longHasRolledDice, longNumberMove, longDiceValues.length,
  longBoardState, longWhiteOffBoard, longBlackOffBoard,
]);




// Аккуратно покидаем уже завершённый стол и идём в лобби этого турнира.
function goToBigTournamentLobby(tournamentId) {
  try { clearInterval(intervalRef?.current); } catch {}
  intervalRef.current = null;

  try { clearInterval(tickRef.current); } catch {}
  tickRef.current = null;

  try {
    if (endModalTimerRef.current) {
      clearTimeout(endModalTimerRef.current);
      endModalTimerRef.current = null;
    }
  } catch {}

  if (tableId) {
    try {
      bigTournamentLongSocket.emit(
        'longLeaveTable',
        {
          tableId:
            Number(tableId),
        }
      );
    } catch {}
  }

  alreadyJoinedRef.current = false;
  dataListenerAttachedRef.current = false;
  endModalOpenRef.current = false;

  // Не оставляем старый Big Tournament tableId в localStorage.
  // Иначе глобальная логика приложения может попытаться вернуть
  // пользователя обратно на уже завершённый стол.
  try {
    const saved =
      localStorage.getItem(
        'bigTournament:lastActiveTableId'
      );

    if (
      !saved ||
      String(saved) === String(tableId)
    ) {
      localStorage.removeItem(
        'bigTournament:lastActiveTableId'
      );
    }
  } catch {}

  const target =
    tournamentId
      ? `/big-tournaments/${tournamentId}`
      : '/big-tournaments';

  // Здесь намеренно делаем полноценный переход страницы.
  // После завершения матча это надёжнее SPA navigate:
  // полностью снимаются старые socket-listeners и состояние стола.
  window.location.replace(target);
}


// Показываем итог матча.
// В Rebuy-раунде проигравшему сразу предлагаем Rebuy,
// не ожидая завершения остальных партий.
function showEndModal({
  winner,
  loser,
  isFinal,
  advanceTo,
  reason,
  resignedBy,
  tournamentId,
  rebuyAvailable,
  rebuyCost,
}) {
  const myUsername = localStorage.getItem('username');

  const winnerName = typeof winner === 'string' ? winner : winner?.username;
  const loserName  = typeof loser  === 'string' ? loser  : loser?.username;

  const iAmWinner = myUsername && winnerName && myUsername === winnerName;
  const iAmLoser  = myUsername && loserName  && myUsername === loserName;

  const offerRebuy =
    !!rebuyAvailable &&
    !!iAmLoser &&
    !isFinal;

  let title = '';
  let subtitle = '';
  let note = '';

  if (offerRebuy) {
    title = translate('jackpotBoard.rebuyAvailableTitle');
    subtitle = translate('jackpotBoard.rebuyLostSubtitle');
    note = translate('jackpotBoard.rebuyCostLong', { cost: Number(rebuyCost || 0) });

  } else if (isFinal) {
    title = iAmWinner
      ? translate('jackpotBoard.championTitle')
      : translate('jackpotBoard.gameOverTitle');
    subtitle = iAmWinner
      ? translate('jackpotBoard.wonTournament')
      : translate('jackpotBoard.eliminatedSorry');

  } else if (iAmWinner && rebuyAvailable) {
    title = translate('jackpotBoard.rebuyRoundVictory');
    subtitle = translate('jackpotBoard.rebuyRoundAdvance');

  } else if (iAmWinner) {
    if (advanceTo === 'final') {
      title = translate('jackpotBoard.advanceFinalTitle');
      subtitle = translate('jackpotBoard.advanceFinalSubtitle');
    } else if (advanceTo === 'semifinal') {
      title = translate('jackpotBoard.advanceSemiTitle');
      subtitle = translate('jackpotBoard.advanceSemiSubtitle');
    } else {
      title = translate('jackpotBoard.victoryTitle');
      subtitle = translate('jackpotBoard.advanceNextRound');
    }

  } else {
    title = translate('jackpotBoard.eliminatedTitle');
    subtitle = translate('jackpotBoard.thanksParticipation');
  }

  if (reason === 'timeout') {
    note = offerRebuy
      ? note
      : (iAmLoser
          ? translate('jackpotBoard.ownTimeout')
          : translate('jackpotBoard.opponentTimeout'));
  } else if (reason === 'resign' && !offerRebuy) {
    note = resignedBy === myUsername
      ? translate('jackpotBoard.ownResigned')
      : translate('jackpotBoard.opponentResigned', { name: resignedBy || '—' });
  }

  setIsFinished(true);
  setResignPending(false);

  try { setBlockStol?.(true); } catch {}

  // Сразу останавливаем локальный таймер и polling.
  // Иначе визуально время может продолжать идти под модалкой.
  try { clearInterval(tickRef.current); } catch {}
  tickRef.current = null;

  try { clearInterval(intervalRef?.current); } catch {}
  intervalRef.current = null;

  endModalOpenRef.current = true;

  setEndModal({
    open: true,
    title,
    subtitle,
    note,
    isFinal: !!isFinal,
    rebuyAvailable: offerRebuy,
    rebuyCost: Number(rebuyCost || 0),
    tournamentId: tournamentId || null,
    rebuyError: '',
  });

  if (endModalTimerRef.current) {
    clearTimeout(endModalTimerRef.current);
    endModalTimerRef.current = null;
  }

  // Для предложения Rebuy автопереход НЕ делаем —
  // игрок сам выбирает «Rebuy» или «Позже».
  if (offerRebuy) {
    return;
  }

  endModalTimerRef.current = setTimeout(() => {
    goToBigTournamentLobby(tournamentId);
  }, 5000);
}


async function performImmediateRebuy() {
  if (
    rebuyPending ||
    !endModal.rebuyAvailable ||
    !endModal.tournamentId
  ) {
    return;
  }

  const token =
    localStorage.getItem('token') || '';

  if (!token) {
    setEndModal(previous => ({
      ...previous,
      rebuyError: translate('jackpotBoard.loginRequired'),
    }));
    return;
  }

  try {
    setRebuyPending(true);

    const response = await fetch(
      `${API_BASE}/big-tournaments/${endModal.tournamentId}/rebuy`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const data = await response.json();

    if (!response.ok || !data?.ok) {
      throw new Error(
        data?.error ||
        translate('jackpotBoard.rebuyFailed')
      );
    }

    if (
      data.balance !== undefined &&
      data.balance !== null
    ) {
      window.dispatchEvent(
        new CustomEvent(
          'balance-updated',
          {
            detail: {
              balance: Number(data.balance),
              source: 'big-tournament-rebuy',
              allowDecrease: true,
            },
          }
        )
      );
    }

    setEndModal(previous => ({
      ...previous,
      title: translate('jackpotBoard.rebuyDoneTitle'),
      subtitle: translate('jackpotBoard.rebuyDoneSubtitle'),
      note: translate('jackpotBoard.charged', { amount: Number(data.cost || 0) }),
      rebuyAvailable: false,
      rebuyError: '',
    }));

    if (endModalTimerRef.current) {
      clearTimeout(endModalTimerRef.current);
    }

    endModalTimerRef.current = setTimeout(() => {
      goToBigTournamentLobby(endModal.tournamentId);
    }, 2200);

  } catch (error) {
    setEndModal(previous => ({
      ...previous,
      rebuyError:
        error?.message ||
        translate('jackpotBoard.rebuyFailed'),
    }));

  } finally {
    setRebuyPending(false);
  }
}


function chooseRebuyLater() {
  if (!endModal.tournamentId) {
    goToBigTournamentLobby(null);
    return;
  }

  goToBigTournamentLobby(
    endModal.tournamentId
  );
}


useEffect(() => {
  return () => {
    if (endModalTimerRef.current) clearTimeout(endModalTimerRef.current);
  };
}, []);




function emitBoardUpdate({
  longTableId,
  boardState,
  longWhiteOffBoard,
  longBlackOffBoard,
  longNumberMove,
  ephemeral = true  // ⚠️ значение по умолчанию
}) {
  safeEmit('longGame_updateBoardState', {
    longTableId: Number(longTableId),
    boardState,
    longWhiteOffBoard,
    longBlackOffBoard,
    longNumberMove,
    ephemeral
  });
  console.log('[SEND] longGame_updateBoardState', { ephemeral });
}




 useEffect(() => {
    const handleColorResolved = (data) => {
      if (colorResolvedRef.current) return;
      
      console.log('[COLOR] Received long_joined event:', data);
      if (String(data.longTableId) === String(tableId)) {
        setLongMyColor(data.myColor);
        setLongOpponentColor(data.myColor === 'white' ? 'black' : 'white');
        colorResolvedRef.current = true;
      }
    };

    bigTournamentLongSocket.on('long_joined', handleColorResolved);
    
    return () => {
      bigTournamentLongSocket.off('long_joined', handleColorResolved);
    };
  }, [tableId]);



useEffect(() => {
  console.log('[MOUNT] BigTournamentBackgammon');
  return () => {
    console.log('[UNMOUNT] BigTournamentBackgammon');
  };
}, []);







// === Логика обрыва/восстановления соединения ===
useEffect(() => {
  if (!bigTournamentLongSocket) return;

  const handleConnect = () => {
    console.log('[SOCKET] reconnect / connect');
    setIsSocketConnected(true);

    // если до этого было отключение – надо ресинхронизировать состояние
    if (wasDisconnected) {
      needResyncOnReconnectRef.current = true;
      wasDisconnected && setWasDisconnected(false);

      // сбрасываем флаг ожидания локального confirm,
      // иначе longDataResponse будет игнорироваться
      awaitingConfirmRef.current = false;
      gameStateHydratedRef.current = false;
      setLongMoveHistory([]);
      setLongDiceValues([]);
      setLongNumberMove(0);

      if (tableId && longUsername) {
        // заново вступаем в комнату стола
        safeEmit('joinLongTable', {
          longTableId: parseInt(tableId, 10),
          playerUsername: longUsername,
        });

        // и сразу запрашиваем полное состояние
        bigTournamentLongSocket.emit('longFetchData', Number(tableId));
      }
    }
  };

  const handleDisconnect = (reason) => {
    console.log('[SOCKET] disconnect:', reason);
    setIsSocketConnected(false);
    setWasDisconnected(true);

    // локальный незавершённый ход считаем «потерянным»,
    // поэтому больше НЕ игнорируем обновления от сервера
    awaitingConfirmRef.current = false;
  };

  bigTournamentLongSocket.on('connect', handleConnect);
  bigTournamentLongSocket.on('disconnect', handleDisconnect);

  return () => {
    bigTournamentLongSocket.off('connect', handleConnect);
    bigTournamentLongSocket.off('disconnect', handleDisconnect);
  };
}, [tableId, longUsername]);


// --- Кто сейчас ходит? ---

useEffect(() => {
  if (!tableId || !longUsername) return;

  ensureBigTournamentLongSocket(longUsername);

  if (alreadyJoinedRef.current) return;
  alreadyJoinedRef.current = true;

  const emitJoin = () => {
    console.log('[CLIENT] joinLongTable (объединённый useEffect)');
    safeEmit('joinLongTable', {
      longTableId: parseInt(tableId, 10),
      playerUsername: longUsername,
    });
  };

  if (bigTournamentLongSocket.connected) {
    emitJoin();
  } else {
    bigTournamentLongSocket.once('connect', emitJoin);
  }

  const handleJoined = ({ longTableId, myColor }) => {
    if (String(longTableId) !== String(tableId)) return;

    setLongMyColor(myColor);
    setLongOpponentColor(myColor === 'white' ? 'black' : 'white');

   
  };

  bigTournamentLongSocket.once('long_joined', handleJoined);

  return () => {
    bigTournamentLongSocket.off('connect', emitJoin);
    bigTournamentLongSocket.off('long_joined', handleJoined);
  };
}, [tableId, longUsername]);





const opponentTime = longMyColor === 'white' ? player2Time : player1Time;


  useEffect(() => {
  if (isSpectator || isMyTurn) return;

  let timeLeft = opponentTime;

  intervalRef.current = setInterval(() => {
    timeLeft -= 1;
    setVisibleOpponentTime(Math.max(0, timeLeft));
  }, 1000);

  return () => {
    clearInterval(intervalRef.current);
    intervalRef.current = null;
  };
}, [isMyTurn, opponentTime, isSpectator]);





useEffect(() => {  function onTimer({ tableId: tid, player1_time_left, player2_time_left }) {
    if (String(tid) !== String(tableId)) return;
    setPlayer1Time(player1_time_left);
    setPlayer2Time(player2_time_left);
  }
  bigTournamentLongSocket.on('longTimerUpdated', onTimer);
  return () => bigTournamentLongSocket.off('longTimerUpdated', onTimer);
}, [tableId]);


useEffect(() => {
  /* перезапускаем, когда меняется очередь */
  clearInterval(tickRef.current);
  tickRef.current = setInterval(() => {
    setPlayer1Time(t =>
      longCurrentTurn === 'player1' ? Math.max(t - 1, 0) : t);
    setPlayer2Time(t =>
      longCurrentTurn === 'player2' ? Math.max(t - 1, 0) : t);
  }, 1000);
  return () => clearInterval(tickRef.current);
}, [longCurrentTurn]);







// заменяем весь эффект на этот
useEffect(() => {
  const onFinish = (payload) => {
    // payload: { winner, loser, isFinal, reason, resignedBy }
    showEndModal(payload);   // <— вместо alert'ов и немедленного navigate('/')
  };

  bigTournamentLongSocket.once('long_gameFinished', onFinish);
  return () => {
    bigTournamentLongSocket.off('long_gameFinished', onFinish);
  };
}, [tableId]);





// useEffect(() => {
//   const onFinish = ({ winner, loser, isFinal, reason, resignedBy }) => {
//     const myUsername = localStorage.getItem('username');

//     // На случай если сервер шлёт объекты
//     const winnerName = typeof winner === 'string' ? winner : winner?.username;
//     const loserName  = typeof loser  === 'string' ? loser  : loser?.username;

//     const isTimeout = reason === 'timeout';

//     // ❗ Без алертов при таймауте: просто уходим в лобби
//     if (!isTimeout) {
//       if (reason === 'resign') {
//         if (resignedBy === myUsername) {
//           alert('Вы сдались. Партия завершена.');
//         } else {
//           alert(`Соперник (${resignedBy}) сдался. Победитель: ${winnerName}`);
//         }
//       } else {
//         // обычное завершение (вывод всех шашек / финал)
//         if (winnerName === myUsername) {
//           alert(isFinal ? '🏆 Поздравляем: вы ПОБЕДИЛИ в турнире!' : '🎉 Поздравляем: вы в финале!');
//         } else {
//           alert('😞 К сожалению, вы выбываете…');
//         }
//       }
//     }

//     // Общая очистка и выход в лобби (и при таймауте, и при прочих причинах)
//     try { clearInterval(intervalRef?.current); } catch {}
//     intervalRef.current = null;
//     try { clearInterval(tickRef.current); } catch {}

//     bigTournamentLongSocket.off('longDataResponse');
//     bigTournamentLongSocket.off('long_joined');

//     if (tableId) {
//       // оставляю тот же формат, что у тебя уже используется, чтобы ничего не сломать
//       bigTournamentLongSocket.emit('longLeaveTable', { tableId });
//     }

//     alreadyJoinedRef.current = false;
//     dataListenerAttachedRef.current = false;

//     setIsFinished(true);
//     navigate('/');
//   };

//   bigTournamentLongSocket.once('long_gameFinished', onFinish);
//   return () => {
//     bigTournamentLongSocket.off('long_gameFinished', onFinish);
//   };
// }, [tableId, navigate]);









useEffect(() => {
  console.log('[LOG] Доска в Display:', longBoardState);
  for (let i = 0; i < longBoardState.length; i++) {
    console.log(`point[${i}] =`, longBoardState[i]);
  }
}, [longBoardState]);

useEffect(() => {
  setLongShowUndoButton(isMyTurn && longMoveHistory.length > 0);
}, [isMyTurn, longMoveHistory]);



useEffect(() => {
  console.log('[LOG] longFirstRolls изменился:', longFirstRolls);
}, [longFirstRolls]);



// сразу после useMemo(isMyTurn)
useEffect(() => {
  // мой ли сейчас ход
  const myTurn =
    (longMyColor === 'white' && longCurrentTurn === 'player1') ||
    (longMyColor === 'black' && longCurrentTurn === 'player2');

  // кнопку показываем ТОЛЬКО когда мой ход и я ещё не бросал
  setLongRollEnabled(myTurn && !longHasRolledDice);
}, [longMyColor, longCurrentTurn, longHasRolledDice]);






useEffect(() => {
  // При смене хода сбрасываем фиксированное начальное значение для головы
  headInitialCountRef.current = null;
  setHeadMoveCount(0);
  setHeadCheckersMoved(0)
}, [longCurrentTurn]);

// const maxHeadCheckers = (headCountBefore, dice) => {
//   const isSpecialDouble =
//     dice.length === 2 &&
//     dice[0] === dice[1] &&
//     [3, 4, 6].includes(dice[0]);
//   return headCountBefore === 15 && isSpecialDouble ? 2 : 1;
// };
const maxHeadCheckers = (headCountBefore, dice) => {
  const isSpecialDouble =
        dice[0] === dice[1] &&          // дубль 3‑3, 4‑4 или 6‑6
        [3, 4, 6].includes(dice[0]);

  return headCountBefore === 15 && isSpecialDouble ? 2 : 1;
};
 



// переключатели авторежимов
const onToggleAutoRoll = useCallback(() => {
  setAutoRoll(v => !v);
}, []);

const onToggleAutoConfirm = useCallback(() => {
  setAutoConfirm(v => !v);
}, []);



const applyAutoLongFirstRoll = useCallback((raw, myColor) => {
  console.group('%c[AUTO] applyAutoLongFirstRoll', 'color:#07c;font-weight:700');
console.log('myColor =', myColor);
console.log('payload  =', raw);

  const flat = (v, idx) => Array.isArray(v) ? v[idx] ?? null : v;

  const player1Roll = flat(raw.player1Roll, 0);
  const player2Roll = flat(raw.player2Roll, 1);
  const { currentTurn } = raw;
console.log('player1Roll =', player1Roll,
            'player2Roll =', player2Roll,
            'currentTurn =', currentTurn);

  setLongFirstRolls({ player1Roll, player2Roll });
  setLongCurrentTurn(currentTurn);
  setLongFirstRollComplete(true);

const iAmWhite = myColor === 'white';
const iAmPlayer1 = iAmWhite;  // цвет определяет роль

const isMyTurn =
  (iAmPlayer1 && currentTurn === 'player1') ||
  (!iAmPlayer1 && currentTurn === 'player2');

// 👇 устанавливаем локальные флаги
setLongHasRolledDice(isMyTurn);     // только победителю = true
// setLongRollEnabled(!isMyTurn);      // проигравшему показываем кнопку

if (isMyTurn) {
  const myDice = iAmPlayer1
    ? [player1Roll, player2Roll]
    : [player2Roll, player1Roll];

  myDice.sort((a, b) => b - a);  // ← теперь порядок гарантирован
console.log('→ isMyTurn computed as', isMyTurn);
console.groupEnd();

  setLongDiceValues(myDice);
  setLongNumberMove(2);
  setLongDisableBoardClicks(false);
} else {
  setLongDiceValues([]);
  setLongNumberMove(0);
  setLongDisableBoardClicks(true);
}

}, []);


 useEffect(() => {
    const listener = (data) => {
      if (!longMyColor && !colorResolvedRef.current) {
        pendingAutoRollRef.current = data;
        return;
      }
      applyAutoLongFirstRoll(data, longMyColor);
    };

    bigTournamentLongSocket.on('long_autoLongFirstRoll', listener);
    return () => bigTournamentLongSocket.off('long_autoLongFirstRoll', listener);
  }, [longMyColor]);

  useEffect(() => {
    if (longMyColor && pendingAutoRollRef.current) {
      applyAutoLongFirstRoll(pendingAutoRollRef.current, longMyColor);
      pendingAutoRollRef.current = null;
    }
  }, [longMyColor]);                   //  ← пустой массив !
// ------------------------------------------------------------------





// useEffect(() => {
//   const onAuto = (data) => {
//     if (!longMyColor) {
//       pendingAutoRollRef.current = data;
//     } else {
//       applyAutoLongFirstRoll(data, longMyColor);
//     }
//   };

//   bigTournamentLongSocket.on('long_autoLongFirstRoll', onAuto);
//   return () => bigTournamentLongSocket.off('long_autoLongFirstRoll', onAuto);
// }, []);



// Как только мы узнали свой цвет – проверяем, не лежат ли данные в буфере
useEffect(() => {
  if (longMyColor && pendingAutoRollRef.current) {
    applyAutoLongFirstRoll(pendingAutoRollRef.current, longMyColor);
    pendingAutoRollRef.current = null;
  }
}, [longMyColor]);









useEffect(() => {
  const handleTableClosed = ({
    tableId: tid,
    tournamentId,
  }) => {
    if (
      String(tid) !==
      String(tableId)
    ) {
      return;
    }

    // Если long_gameFinished уже пришёл, не трогаем
    // нормальную модалку победы/Rebuy.
    if (endModalOpenRef.current) {
      return;
    }

    // Fallback: событие завершения могло потеряться при reconnect.
    // Закрытый стол не должен оставаться на экране.
    setIsFinished(true);
    setResignPending(false);

    try { clearInterval(tickRef.current); } catch {}
    tickRef.current = null;

    try { clearInterval(intervalRef?.current); } catch {}
    intervalRef.current = null;

    goToBigTournamentLobby(
      tournamentId
    );
  };

  bigTournamentLongSocket.on(
    'long_tableClosed',
    handleTableClosed
  );

  return () =>
    bigTournamentLongSocket.off(
      'long_tableClosed',
      handleTableClosed
    );
}, [tableId]);

// useEffect(() => {
//   const handleTableClosed = ({ tableId }) => {
//     console.log(`[CLIENT] Получено long_tableClosed: стол #${tableId} закрыт`);
//     // ✅ Устанавливаем флаг завершения, чтобы заблокировать дальнейшие действия
//     setIsFinished(true);
//     // ✅ Перенаправляем пользователя в лобби (или на главную)
//     navigate('/');
//   };

//   bigTournamentLongSocket.on('long_tableClosed', handleTableClosed);

//   return () => {
//     bigTournamentLongSocket.off('long_tableClosed', handleTableClosed);
//   };
// }, []);



// ─────────────────────────────────────────────────────────────
//  Снятие шашки (bear‑off)  ***ИСПОЛЬЗУЕТСЯ и для drag&drop, и для click***
// ─────────────────────────────────────────────────────────────
const performBearOff = (fromIdx, dieVal) => {
  /* 0.  Снимем копии «до»‑состояния для истории (undo) */
  const boardBefore        = deepCopyBoard(longBoardState);
  const prevWhiteOffBefore = [...(Array.isArray(longWhiteOffBoard) ? longWhiteOffBoard : [])];
  const prevBlackOffBefore = [...(Array.isArray(longBlackOffBoard) ? longBlackOffBoard : [])];


  /* 1.  Копируем доску и снимаем верхнюю шашку из пункта fromIdx */
  const nextBoard = deepCopyBoard(longBoardState);
  const checker   = nextBoard[fromIdx].pop();              // именно та шашка, которую снимаем

  /* 2.  Формируем ***новые*** массивы off‑board — они нужны и setState‑у, и emit‑у */
let nextWhiteOff = [...(Array.isArray(longWhiteOffBoard) ? longWhiteOffBoard : [])];
let nextBlackOff = [...(Array.isArray(longBlackOffBoard) ? longBlackOffBoard : [])];


  if (longMyColor === 'white') {
    nextWhiteOff = [...nextWhiteOff, checker];             // белая шашка уходит в белый «off»
  } else {
    nextBlackOff = [...nextBlackOff, checker];             // чёрная — в чёрный «off»
  }

  /* 3.  Обновляем React‑состояние (setState) уже готовыми массивами */
  setLongWhiteOffBoard(nextWhiteOff);
  setLongBlackOffBoard(nextBlackOff);
  setLongBoardState(nextBoard);

  /* 4.  Сохраняем шаг в историю для кнопки «Undo» */
  setLongMoveHistory(prev => [
    ...prev,
    {
      type              : 'bearOff',
      from              : fromIdx,
      boardBefore,
      prevWhiteOffBoard : prevWhiteOffBefore,
      prevBlackOffBoard : prevBlackOffBefore,
      prevDiceValues    : [...longDiceValues],
      prevNumberMove    : longNumberMove
    }
  ]);
  setLongLastMoveType('bearOff');

  /* 5.  Корректируем кубики и число оставшихся ходов локально */
  const diceLeft = [...longDiceValues];
  diceLeft.splice(diceLeft.indexOf(dieVal), 1);            // убираем использованный кубик
  setLongDiceValues(diceLeft);
  setLongNumberMove(n => n - 1);

  /* 6.  Отправляем на сервер ***те же самые*** nextWhiteOff / nextBlackOff */
  
  const totalOff = longMyColor === 'white'
  ? nextWhiteOff.length
  : nextBlackOff.length;

// if (totalOff === 15) {
//   longConfirmMove({
//     boardState: nextBoard,
//     whiteOffBoard: nextWhiteOff,
//     blackOffBoard: nextBlackOff
//   });
// }
if (totalOff === 15) {
  // игра окончена — обнуляем локальные состояния
  setLongDiceValues([]);        // убираем оставшиеся кубики
  setLongNumberMove(0);         // больше нет доступных ходов

  longConfirmMove({
    boardState: nextBoard,
    whiteOffBoard: nextWhiteOff,
    blackOffBoard: nextBlackOff
  });

  return; // ⛔️ больше ничего не делаем в этой функции
}


emitBoardUpdate({
  longTableId       : parseInt(tableId, 10),
  boardState        : nextBoard,
  longWhiteOffBoard : nextWhiteOff,
  longBlackOffBoard : nextBlackOff,
  longNumberMove    : longNumberMove - 1
});

  // safeEmit('long_updateNumberMove', {    
  //   longTableId   : parseInt(tableId, 10),    
  //   currentPlayer : longCurrentTurn,
  //   longNumberMove: longNumberMove - 1
  // });
  awaitingConfirmRef.current = true;

};




const undoLastMove = () => {
  if (longMoveHistory.length === 0) {
    
    return;
  }

  const last = longMoveHistory[longMoveHistory.length - 1];

  /* --- общее восстановление доски/кубиков/счётчиков ---------- */
  setLongBoardState(deepCopyBoard(last.boardBefore));
  setLongDiceValues([...last.prevDiceValues]);
  setLongNumberMove(last.prevNumberMove);

  /* --- если это был bear-off – откатить и off-board ----------- */
  if (last.type === 'bearOff') {
    setLongWhiteOffBoard(last.prevWhiteOffBoard);
    setLongBlackOffBoard(last.prevBlackOffBoard);
    // console.log('[Undo] Вернули шашку из off-board на пункт',
    //             indexToVisualNumber(last.from));
  } else {
    /* ход с головы? – корректируем счётчик */
    if ((longMyColor === 'white' && last.from === 23) ||
        (longMyColor === 'black' && last.from === 11)) {
      setHeadMoveCount(prev => Math.max(prev - 1, 0));
      setHeadCheckersMoved(prev => Math.max(prev - 1, 0)); 
    }
  }

  /* --- чистим историю и отправляем событие ------------------- */
  setLongMoveHistory(prev => prev.slice(0, -1));

  safeEmit('longGame_undoMove', {
    longTableId      : parseInt(tableId, 10),
    newBoardState    : last.boardBefore,
    longWhiteOffBoard: last.type === 'bearOff'
                         ? last.prevWhiteOffBoard
                         : longWhiteOffBoard,
    longBlackOffBoard: last.type === 'bearOff'
                         ? last.prevBlackOffBoard
                         : longBlackOffBoard,
    longNumberMove   : last.prevNumberMove
  });
};




function allInHome(board, colour) {
  const [lo, hi] = colour === 'white' ? [0, 5] : [12, 17];
  for (let i = 0; i < 24; i++) {
    if (board[i].length && board[i][0].color === colour) {
      if (i < lo || i > hi) return false;
    }
  }
  return true;
}


function canBearOff(board, colour, pointIdx, die) {
  if (!allInHome(board, colour)) return false;       // ещё не все дома

  if (colour === 'white') {
    // точное/overshoot правило для белых
    if (pointIdx === die - 1) return true;
    if (pointIdx < die - 1) {
      for (let i = pointIdx + 1; i <= 5; i++) {
        if (board[i].length && board[i][0].color === 'white') return false;
      }
      return true;
    }
//   } else { // black
//    const target = 12 + die - 1;            // пункт, который «закрывает» кубик
//   if (pointIdx === target) return true;   // точный бросок

//   /* overshoot: кубик больше, чем нужно */
//   if (pointIdx < target) {
//     for (let i = pointIdx + 1; i <= target; i++) {
//       if (board[i].length && board[i][0].color === 'black') return false;
//     }
//     return true;                          // «перебор» разрешён
//   }
// }
// новый вариант предложен, теоретически это против бага который позволял выводить шашки со второго пункта, из за неверного расчета.
} else {                     // ---------- ЧЁРНЫЕ ----------
   const posInPath = blackLongPath.findIndex(p => p - 1 === pointIdx);
   if (posInPath === -1) return false;
   const distance = blackLongPath.length - posInPath; // точный кубик

   if (die === distance) return true;                  // точный

   if (die > distance) {                               // перебор
     for (let i = 0; i < posInPath; i++) {
       const idx = blackLongPath[i] - 1;
       if (board[idx].length && board[idx][0].color === 'black')
         return false;                                 // дальняя шашка
     }
     return true;                                      // перебор допустим
   }
   return false;                                       // die < distance
 }
  return false;
}
 


const longConfirmMove = useCallback((opts = {}) => {
  const {
    boardState = longBoardState,
    whiteOffBoard = longWhiteOffBoard,
    blackOffBoard = longBlackOffBoard
  } = opts;

  if (!tableId) {
    console.error('tableId не определен');
    return;
  }

  if (!longCurrentTurn) {
    console.error('currentTurn не определен');
    return;
  }

  const boardStateString = JSON.stringify(boardState);
  if (!boardStateString) {
    console.error('boardState is undefined or empty');
    return;
  }

  setLongMoveHistory([]);
  justConfirmedRef.current = true;

  setLongDisableBoardClicks(true);
  setLongRollEnabled(false);

  const nextTurn = longCurrentTurn === 'player1' ? 'player2' : 'player1';
  setLongCurrentTurn(nextTurn);
  setLongFirstRollComplete(true);
  setLongFirstMoveComplete(true);
  setLongUsedRolls([]);
  setLongRolledDice([]);
  setLongFirstRolls({});
  setLongHasRolledDice(true);

     setTimeout(() => {
  console.log('[Long] ЗАДЕРЖКА 700 мс — отправка confirmMove');
  safeEmit('long_confirmMove', {
    tableId,
    player: longCurrentTurn,
    longBoardState: boardStateString,
    longWhiteOffBoard: whiteOffBoard,
    longBlackOffBoard: blackOffBoard,
    longfirstRollComplete: true,
    longfirstMoveComplete: true,
    longNumberMove: 0, 
  });
  }, 700);
}, [
  tableId,
  longCurrentTurn,
  longBoardState,
  longWhiteOffBoard,
  longBlackOffBoard
]);





const longHandleConfirmed = useCallback((data) => {
  const {
    tableId: incomingTableId,
    longBoardState,
    newCurrentTurn,
    longWhiteOffBoard,
    longBlackOffBoard,
    longHasRolledDice,
    numberMove,
    firstMoveComplete,
  } = data;

  if (typeof data.player1_time_left === 'number') {
  setPlayer1Time(data.player1_time_left);
}
if (typeof data.player2_time_left === 'number') {
  setPlayer2Time(data.player2_time_left);
}
clearInterval(tickRef.current); // Очищаем предыдущий таймер
tickRef.current = setInterval(() => {
  setPlayer1Time(t =>
    data.current_turn === 'player1' ? Math.max(t - 1, 0) : t);
  setPlayer2Time(t =>
    data.current_turn === 'player2' ? Math.max(t - 1, 0) : t);
}, 1000);


  if (String(incomingTableId) !== String(tableId)) return;
  awaitingConfirmRef.current = false; // ⬅️ Вот ЭТО обязательно

  justConfirmedRef.current = false;
  setLongDisableBoardClicks(false);
  setLongBoardState(JSON.parse(longBoardState));
  setLongCurrentTurn(newCurrentTurn);
  setLongHasRolledDice(false);
  setLongFirstRolls({});
  setLongRolledDice([]);
  setLongNumberMove(numberMove || 0);
  setLongFirstRollComplete(firstMoveComplete);
  setLongFirstMoveComplete(true);

  const myRole = (longPlayerColor === 'white') ? 'player1' : 'player2';
  if (newCurrentTurn === myRole) {
    setLongHasRolledDice(false);
  }
  clearInterval(tickRef.current);
tickRef.current = setInterval(() => {
  setPlayer1Time(t =>
    newCurrentTurn === 'player1' ? Math.max(t - 1, 0) : t);
  setPlayer2Time(t =>
    newCurrentTurn === 'player2' ? Math.max(t - 1, 0) : t);
}, 1000);

}, [tableId, longPlayerColor]);



useEffect(() => {
  bigTournamentLongSocket.on('long_confirmed', longHandleConfirmed);
  return () => {
    bigTournamentLongSocket.off('long_confirmed', longHandleConfirmed);
  };
}, [longHandleConfirmed]);





 useEffect(() => {
    const storedUser = localStorage.getItem('username') || '';
    if (!storedUser || !tableId) {
      setLongLoading(false);
      setLongError(translate('jackpotBoard.missingGameData'));
      return;
    }
    setUsername(storedUser);

    const fetchData = async () => {
      console.log('[DEBUG] fetchData ВЫЗВАН');
      try {
         console.log('[DEBUG] 🔽 fetchData вызван');

        setLongLoading(true);
        
        if (!alreadyJoinedRef.current) {
          alreadyJoinedRef.current = true;
          console.log('[DEBUG] 🔁 joinLongTable отправляется');
          safeEmit('joinLongTable', {
            longTableId: parseInt(tableId, 10),
            playerUsername: storedUser,
          });
        }

      

      } catch (err) {
        console.error('Ошибка при подключении:', err);
        setLongError(translate('jackpotBoard.connectionError'));
        setLongLoading(false);
      }
    };

    if (bigTournamentLongSocket.connected) {
      fetchData();
    } else {
      bigTournamentLongSocket.once('connect', fetchData);
    }

    // Обработчик обновления игры
    const handleGameUpdated = (game) => {
      // Пропускаем, если игра завершена.
      if (game.status === 'finished') {
        setIsFinished(true);
        setResignPending(false);

        try { clearInterval(tickRef.current); } catch {}
        tickRef.current = null;

        try { clearInterval(intervalRef?.current); } catch {}
        intervalRef.current = null;

        goToBigTournamentLobby(
          game.tournament_id
        );

        return;
      }

      console.log('[longGameUpdated] Received game update');
      setLongLoading(false);

      const normalizeRolls = (raw) => {
        let value = raw;

        try {
          if (typeof value === 'string') {
            value = JSON.parse(value);
          }
        } catch (_) {
          value = [];
        }

        if (!Array.isArray(value)) return [];
        if (Array.isArray(value[0])) return value;
        if (value.length === 2) return [value];
        return [];
      };

      const player1Rolls =
        normalizeRolls(game.player1_rolls);

      const player2Rolls =
        normalizeRolls(game.player2_rolls);

      const me = storedUser;
      const myRole =
        game.player1_name === me
          ? 'player1'
          : (
              game.player2_name === me
                ? 'player2'
                : null
            );

      const myColor =
        myRole === 'player1'
          ? 'white'
          : (
              myRole === 'player2'
                ? 'black'
                : null
            );

      const currentTurn =
        game.current_turn || null;

      const itsMyTurn =
        !!myRole &&
        currentTurn === myRole;

      const myHasRolled =
        myRole === 'player1'
          ? !!game.hasRolledDicePlayer1
          : (
              myRole === 'player2'
                ? !!game.hasRolledDicePlayer2
                : false
            );

      const opponentHasRolled =
        myRole === 'player1'
          ? !!game.hasRolledDicePlayer2
          : (
              myRole === 'player2'
                ? !!game.hasRolledDicePlayer1
                : false
            );

      const myMovesLeft =
        myRole === 'player1'
          ? Number(game.numberMovePlayer1 ?? 0)
          : (
              myRole === 'player2'
                ? Number(game.numberMovePlayer2 ?? 0)
                : 0
            );

      setLongPlayer1Name(
        game.player1_name || ''
      );

      setLongPlayer2Name(
        game.player2_name || ''
      );

      setLongCurrentTurn(currentTurn);

      setLongFirstRollComplete(
        !!game.firstRollComplete
      );

      setLongFirstMoveComplete(
        !!game.firstMoveComplete
      );

      if (myColor) {
        setLongMyColor(myColor);
        setLongPlayerColor(myColor);
        setLongOpponentColor(
          myColor === 'white'
            ? 'black'
            : 'white'
        );
      }

      if (
        typeof game.player1_time_left ===
        'number'
      ) {
        setPlayer1Time(
          game.player1_time_left
        );
      }

      if (
        typeof game.player2_time_left ===
        'number'
      ) {
        setPlayer2Time(
          game.player2_time_left
        );
      }

      try {
        const parsedBoard =
          typeof game.board_state ===
          'string'
            ? JSON.parse(
                game.board_state
              )
            : (
                game.board_state ||
                Array.from(
                  { length: 24 },
                  () => []
                )
              );

        setLongBoardState(
          Array.isArray(parsedBoard)
            ? parsedBoard
            : []
        );
      } catch (e) {
        console.error(
          'Ошибка парсинга доски:',
          e
        );
      }

      try {
        const offBoard =
          typeof game.off_board ===
          'string'
            ? JSON.parse(
                game.off_board
              )
            : (
                game.off_board || {
                  white: [],
                  black: [],
                }
              );

        setLongWhiteOffBoard(
          Array.isArray(offBoard?.white)
            ? offBoard.white
            : []
        );

        setLongBlackOffBoard(
          Array.isArray(offBoard?.black)
            ? offBoard.black
            : []
        );
      } catch (e) {
        console.error(
          'Ошибка парсинга off-board:',
          e
        );

        setLongWhiteOffBoard([]);
        setLongBlackOffBoard([]);
      }

      if (game.player1_profile) {
        setPlayer1Profile({
          avatar:
            game.player1_profile.avatar ??
            null,

          rating:
            game.player1_profile.rating ??
            null,
        });
      }

      if (game.player2_profile) {
        setPlayer2Profile({
          avatar:
            game.player2_profile.avatar ??
            null,

          rating:
            game.player2_profile.rating ??
            null,
        });
      }

      /*
       * Критично для F5:
       * numberMove и hasRolled восстанавливаются вместе.
       * Раньше hasRolled становился true,
       * а numberMove оставался начальным 0.
       */
      setLongHasRolledDice(
        itsMyTurn && myHasRolled
      );

      setLongNumberMove(
        itsMyTurn
          ? Math.max(
              0,
              Number.isFinite(myMovesLeft)
                ? myMovesLeft
                : 0
            )
          : 0
      );

      if (itsMyTurn && myHasRolled) {
        const myRolls =
          myRole === 'player1'
            ? player1Rolls
            : player2Rolls;

        const lastRoll =
          myRolls.at(-1) || [];

        if (lastRoll.length >= 2) {
          const [d1, d2] = lastRoll;

          setLongRolledDice(lastRoll);

          setLongDiceValues(
            d1 === d2
              ? [d1, d1, d1, d1]
              : [d1, d2]
          );
        } else {
          setLongRolledDice([]);
          setLongDiceValues([]);
        }
      } else {
        const opponentRolls =
          myRole === 'player1'
            ? player2Rolls
            : player1Rolls;

        const opponentLastRoll =
          opponentHasRolled
            ? (
                opponentRolls.at(-1) ||
                []
              )
            : [];

        setLongRolledDice(
          opponentLastRoll
        );

        setLongDiceValues([]);
      }

      setLongRollEnabled(
        itsMyTurn && !myHasRolled
      );

      awaitingConfirmRef.current = false;
      justConfirmedRef.current = false;
      setLongMoveHistory([]);
      setLongShowUndoButton(false);
      setLongUsedRolls([]);
      setHeadMoveCount(0);
      setHeadCheckersMoved(0);
      headInitialCountRef.current = null;
      setLongDisableBoardClicks(false);

      gameStateHydratedRef.current =
        true;
    };

    bigTournamentLongSocket.on('longGameUpdated', handleGameUpdated);
    
    return () => {
      bigTournamentLongSocket.off('longGameUpdated', handleGameUpdated);
      safeEmit('longLeaveTable', { tableId: parseInt(tableId, 10) });
    };
  }, [tableId]);
  

useEffect(() => {
  if (!tableId || !longUsername) return;

  const send = () => {
    if (isFinished) {
      console.log('[STOP] Турнир завершён — polling остановлен');
      return;
    }
    console.log('[FETCH] emit longFetchData', tableId);
    bigTournamentLongSocket.emit('longFetchData', Number(tableId));
  };

  const handleLongData = (data) => {
    console.log('[SOCKET] longDataResponse', data);

   if (!data) return;

    // Fallback: если long_gameFinished потерялся при reconnect,
    // статус finished всё равно выведет нас со старого стола.
    if (data.status === 'finished') {
      setIsFinished(true);
      setResignPending(false);

      try { clearInterval(tickRef.current); } catch {}
      tickRef.current = null;

      try { clearInterval(intervalRef?.current); } catch {}
      intervalRef.current = null;

      goToBigTournamentLobby(
        data.tournament_id
      );

      return;
    }

    if (awaitingConfirmRef.current) {
    console.log('[SKIP] локальный ход не подтверждён — игнорируем update');
    return;
  }


  if ('tournamentStageLabel' in data) setTournamentStageLabel(data.tournamentStageLabel);
  if ('tournamentPrize' in data) setTournamentPrize(data.tournamentPrize);

const me = localStorage.getItem('username') || '';
const myColorNow = detectMyColor(data, me);
if (myColorNow) {
  setLongMyColor(myColorNow);
  setLongOpponentColor(myColorNow === 'white' ? 'black' : 'white');
}

if (String(data.long_table_id) !== String(tableId)) {
  console.warn("[TournamentMatch] Данные не для нашего стола:", data.table_id);
  return;
}

const isBoardSame = JSON.stringify(data.board_state) === JSON.stringify(longBoardState);
if (!isBoardSame) {
  let parsedBoard = data.board_state;
  try {
    if (typeof parsedBoard === 'string') parsedBoard = JSON.parse(parsedBoard);
    if (typeof parsedBoard === 'string') parsedBoard = JSON.parse(parsedBoard); // двойной парс, если нужно
  } catch (err) {
    console.error('[ERROR] Не удалось распарсить board_state:', err);
    parsedBoard = [];
  }
  setLongBoardState(parsedBoard || []);
}

setLongLoading(false);
setLongFirstMoveComplete(data.firstMoveComplete || false);
setLongFirstRollComplete(data.firstMoveComplete || false);

const normalizeRolls = (raw) => {
  if (!Array.isArray(raw)) return [];
  if (Array.isArray(raw[0])) return raw;
  if (raw.length === 2) return [raw];
  return [];
};

const parsedPlayer1Rolls = normalizeRolls(typeof data.player1_rolls === 'string' ? JSON.parse(data.player1_rolls) : data.player1_rolls);
const parsedPlayer2Rolls = normalizeRolls(typeof data.player2_rolls === 'string' ? JSON.parse(data.player2_rolls) : data.player2_rolls);

if (data.firstRollComplete && !data.firstMoveComplete) {
  const currentPlayer = data.current_turn;
  const last = currentPlayer === 'player1'
    ? parsedPlayer1Rolls.at(-1) || []
    : parsedPlayer2Rolls.at(-1) || [];

  setLongFirstRolls({
    player1Roll: last[0] ?? null,
    player2Roll: last[1] ?? null,
  });
} else {
  setLongFirstRolls(null);
}

setLongWhiteOffBoard(Array.isArray(data.white_off_board) ? data.white_off_board : []);
setLongBlackOffBoard(Array.isArray(data.black_off_board) ? data.black_off_board : []);

setLongCurrentTurn(data.current_turn || null);
setLongPlayer1Name(data.player1_name || null);
setLongPlayer2Name(data.player2_name || null);



// >>> принять профили для аватарки/рейтинга
if (data.player1_profile) {
  setPlayer1Profile({
    avatar: data.player1_profile.avatar ?? null,
    rating: data.player1_profile.rating ?? null,
  });
} else {
  setPlayer1Profile({ avatar: null, rating: null });
}
if (data.player2_profile) {
  setPlayer2Profile({
    avatar: data.player2_profile.avatar ?? null,
    rating: data.player2_profile.rating ?? null,
  });
} else {
  setPlayer2Profile({ avatar: null, rating: null });
}
// <<<



if (typeof data.player1_time_left === 'number')
    setPlayer1Time(data.player1_time_left);
  if (typeof data.player2_time_left === 'number')
    setPlayer2Time(data.player2_time_left);

  clearInterval(tickRef.current); // Очищаем предыдущий таймер
tickRef.current = setInterval(() => {
  setPlayer1Time(t =>
    data.current_turn === 'player1' ? Math.max(t - 1, 0) : t);
  setPlayer2Time(t =>
    data.current_turn === 'player2' ? Math.max(t - 1, 0) : t);
}, 1000);

const myUsername = localStorage.getItem("username") || "";
let myColor = null;
if (data.player1_name && data.player2_name && myUsername) {
  myColor = data.player1_name === myUsername ? 'white' : 'black';
  setLongPlayerColor(myColor);
  setLongOpponentColor(myColor === 'white' ? 'black' : 'white');
} else {
  console.warn('[handleTournamentDataResponse] Не хватает данных для определения цвета:', {
    player1: data.player1_name,
    player2: data.player2_name,
    myUsername,
  });
}

const iAmWhite = myColor === "white";
const hasRolledAlready = iAmWhite ? data.hasRolledDicePlayer1 : data.hasRolledDicePlayer2;
const opponentHasRolled = iAmWhite ? data.hasRolledDicePlayer2 : data.hasRolledDicePlayer1;
setLongHasRolledDice(hasRolledAlready);

const lastRollP1 = parsedPlayer1Rolls.at(-1) || [];
const lastRollP2 = parsedPlayer2Rolls.at(-1) || [];

const movesLeftServer = iAmWhite
  ? (data.numberMovePlayer1 ?? 0)
  : (data.numberMovePlayer2 ?? 0);
if (typeof movesLeftServer === 'number') {
  setLongNumberMove(movesLeftServer);
}

const itsMyTurn = (
  (iAmWhite && data.current_turn === "player1") ||
  (!iAmWhite && data.current_turn === "player2")
);

if (itsMyTurn) {
  if (hasRolledAlready) {
    const myLastRoll = iAmWhite ? lastRollP1 : lastRollP2;
    setLongRolledDice(myLastRoll);

    const [d1, d2] = myLastRoll;
    const isDouble = d1 === d2;
    const diceArray = isDouble ? [d1, d1, d1, d1] : [d1, d2];
    setLongDiceValues(diceArray);
  } else {
    setLongRolledDice([]);
  }
} else {
  if (opponentHasRolled) {
    const oppLastRoll = iAmWhite ? lastRollP2 : lastRollP1;
    setLongRolledDice(oppLastRoll);
  } else {
    setLongRolledDice([]);
  }
}

const canRollDice = itsMyTurn && !hasRolledAlready;
setLongRollEnabled(canRollDice);

awaitingConfirmRef.current = false;
setLongMoveHistory([]);
setLongShowUndoButton(false);
setLongUsedRolls([]);
setHeadMoveCount(0);
setHeadCheckersMoved(0);
headInitialCountRef.current = null;
setLongDisableBoardClicks(false);
gameStateHydratedRef.current = true;

  };

  /*
   * Сначала подписываемся, и только потом отправляем первый запрос.
   * Раньше быстрый longDataResponse мог прийти до установки listener.
   */
  bigTournamentLongSocket.on(
    'longDataResponse',
    handleLongData
  );

  gameStateHydratedRef.current = false;

  send(); // первый запрос после установки listener

  intervalRef.current =
    setInterval(send, 4000);

  return () => {
    clearInterval(intervalRef.current);

    bigTournamentLongSocket.off(
      'longDataResponse',
      handleLongData
    );
  };
}, [tableId, longUsername,isFinished]);


  function calculateRealMoves(board, playerColor, diceArray) {
    let legalMovesCount = 0;
    console.log("[DEBUG] calculateRealMoves - запуск проверки допустимых ходов");
    
    for (let from = 0; from < board.length; from++) {
      // Проверяем, что в данной точке есть шашки нужного цвета.
      if (board[from].length > 0 && board[from][0].color === playerColor) {
      
        for (let die of diceArray) {
          // Для белых ход идёт по уменьшению индекса, для чёрных – по увеличению.
          let target = playerColor === 'white' ? from - die : from + die;
       
          
          // Если целевой индекс выходит за границы доски – ход невозможен.
          if (target < 0 || target >= board.length) {
          
            continue;
          }
          
          const targetPoint = board[target];
          if (!targetPoint || targetPoint.length === 0) {
          
            legalMovesCount++;
          } else if (targetPoint.every(ch => ch.color === playerColor)) {
          
            legalMovesCount++;
          } else {
           
          }
        }
      }
    }
    
   
    return legalMovesCount;
  }
  
  








  function allCheckersInHome(board, playerColor) {
    if (playerColor === 'white') {
      // Проверяем, что ни одна белая шашка не находится вне зон 1-6 (индексы 0-5)
      for (let i = 0; i < board.length; i++) {
        if (board[i] && board[i].length > 0) {
          for (let checker of board[i]) {
            if (checker.color === 'white' && (i < 0 || i > 5)) {
              return false;
            }
          }
        }
      }
    } else {
      // Для чёрных разрешён вывод только если все шашки находятся в зоне 19-24 (индексы 18-23)
      for (let i = 0; i < board.length; i++) {
        if (board[i] && board[i].length > 0) {
          for (let checker of board[i]) {
          if (checker.color === 'black' && (i < 12 || i > 17)) {
              return false;
            }
          }
        }
      }
    }
    return true;
  }
  






/**
 * Проверяет, не образуется ли «прайм» (6+ подряд) для игрока `playerColor`
 * с учётом того, что мы обрезаем маршрут на «самой последней (ближайшей к дому соперника)» шашке врага.
 *
 * @param {Array<Array<{color:string}>>} board - Массив из 24 стэков (board[0..23]),
 *                                              каждый элемент — массив шашек [{ color:'white'|'black' }, ...].
 * @param {string} playerColor                 - 'white' или 'black'
 * @returns {boolean} true, если ход создаёт 6+ подряд (прайм), иначе false
 */

/**
 * Проверяет «правило прайма» для длинных нард, исходя из “хода врага”:

 * @param {Array<Array<{color:string}>>} board 
 *          Массив из 24 стэков (индексы 0..23).
 * @param {string} playerColor 
 *          Ваш цвет ('white' или 'black').
 * @return {boolean} true, если ход нарушает правило прайма, иначе false.
 */

 function violatesPrimeRule(board, currentPlayer) {
 

  // Определяем цвет соперника:
  const enemyColor = (currentPlayer === 'white') ? 'black' : 'white';

  // Маршруты “длинных” нард по движению:
  // - Белые: 24..13, потом 12..1
  // - Чёрные: 12..1, потом 24..13
  // Если соперник = 'white', его маршрут => whiteRouteFull
  // Если соперник = 'black', его маршрут => blackRouteFull
  const whiteRouteFull = [
    24, 23, 22, 21, 20, 19, 18,
    17, 16, 15, 14, 13,
    12, 11, 10,  9,  8,  7,
     6,  5,  4,  3,  2,  1
  ];
  const blackRouteFull = [
    12, 11, 10,  9,  8,  7,  6,
     5,  4,  3,  2,  1,
    24, 23, 22, 21, 20, 19,
    18, 17, 16, 15, 14, 13
  ];

  // Выбираем маршрут соперника:
  const enemyRoute = (enemyColor === 'white') ? whiteRouteFull : blackRouteFull;

  // Цвет, чьи «6 подряд» мы проверяем — это текущий игрок.
  // Если ходят белые => смотрим, не строят ли белые 6 подряд
  // «вперёд» по маршруту соперника.
  // Если ходят чёрные => аналогично.
  const checkColor = currentPlayer;



  // 1) Найти «передовую» шашку соперника (самую дальнюю к дому),
  //    идя с КОНЦА массива: i = enemyRoute.length-1 ... 0
  //    Первая встреченная шашка (enemyColor) будет самой «высокой» в этом маршруте.
  let frontIndex = -1;
  let frontPoint = null;

  for (let i = enemyRoute.length - 1; i >= 0; i--) {
    const pt = enemyRoute[i];
    const stack = board[pt - 1] || [];
    if (Array.isArray(stack) && stack.length > 0 && stack[0] && stack[0].color === enemyColor) {

      frontIndex = i;
      frontPoint = pt;
      break;
    }
  }

  if (frontIndex === -1) {
   
    return false;
  }



  // 2) Всё, что идёт после frontIndex, — «вперёд по движению» соперника.
  //    Проверяем, нет ли там 6 подряд пунктов checkColor (тек.игрока).
  let currentStreak = 0;

  for (let i = frontIndex + 1; i < enemyRoute.length; i++) {
    const pt = enemyRoute[i];
    const stack = board[pt - 1] || [];
    const top = stack[0];

    if (top && top.color === checkColor) {
      currentStreak++;
      if (currentStreak >= 6) {
      
        return true;
      }
    } else {
      currentStreak = 0; // прервалось
    }
  }

  
  return false;
}



function isLegalMoveWithPrimeCheck(board, fromIndex, die, playerColor) {
  const pathToUse = playerColor === 'white' ? whiteLongPath : blackLongPath;
  const toIndex   = fromIndex + die;

  /* ───── BEAR‑OFF: только через canBearOff ───── */
  if (toIndex >= pathToUse.length) {
    const pointIdx = pathToUse[fromIndex] - 1;
    return canBearOff(board, playerColor, pointIdx, die);  // ✅ Строгая проверка
  }
  /* ────────────────────────────────────────────── */

  /* дальше — обычные проверки (прайм, битые пункты и т.п.) */
  const fromBoardIdx = pathToUse[fromIndex] - 1;
  const toBoardIdx   = pathToUse[toIndex]   - 1;

  if (!isMovePossible(board, pathToUse, fromIndex, die, playerColor))
    return false;

  // симуляция для проверки «прайма»
  const simulated = deepCopyBoard(board);
  const checker   = simulated[fromBoardIdx].pop();
  simulated[toBoardIdx].push(checker);

  return !violatesPrimeRule(simulated, playerColor);
}




//  function isLegalMoveWithPrimeCheck(board, fromIndex, die, playerColor) {
//   const pathToUse = playerColor === 'white' ? whiteLongPath : blackLongPath;
//   const toIndex   = fromIndex + die;

//   /* ───── BEAR‑OFF / overshoot ───── */
//   if (toIndex >= pathToUse.length) {
//     const pointIdx = pathToUse[fromIndex] - 1;   // индекс на board (0‑23)

//     /* 1.   классическое правило: все шашки уже дома? */
//     if (canBearOff(board, playerColor, pointIdx, die)) return true;

//     /* 2.   «мягкое» правило: после входа последней шашки все окажутся дома? */
//     const tmp = deepCopyBoard(board);
//     tmp[pointIdx].pop();                         // виртуально снимаем её с пункта
//     return allInHome(tmp, playerColor);          // true → разрешаем ход
//   }
//   /* ───────────────────────────────── */

//   /* дальше — обычные проверки (прайм, битые пункты и т.п.) */
//   const fromBoardIdx = pathToUse[fromIndex] - 1;
//   const toBoardIdx   = pathToUse[toIndex]   - 1;

//   if (!isMovePossible(board, pathToUse, fromIndex, die, playerColor))
//     return false;

//   // симуляция для проверки «прайма»
//   const simulated = deepCopyBoard(board);
//   const checker   = simulated[fromBoardIdx].pop();
//   simulated[toBoardIdx].push(checker);

//   return !violatesPrimeRule(simulated, playerColor);
// }




function calculateUsableDice(board, playerColor, diceArray) {
  



// ─── helper: перебираем все цепочки ходов ─────────────────────────
function dfs(boardState, diceLeft, headMoved = 0) {
  if (diceLeft.length === 0) return 0;
  const die        = diceLeft[0];
  const restDice   = diceLeft.slice(1);
  let   bestResult = 0;

  const pathToUse = playerColor === 'white' ? whiteLongPath : blackLongPath;

  for (let pos = 0; pos < pathToUse.length; pos++) {
    const fromIdx = pathToUse[pos] - 1;
    if (!boardState[fromIdx].length ||
        boardState[fromIdx][0].color !== playerColor) continue;

    const isHead = (fromIdx === headBoardIndex);
    if (isHead && headMoved >= headLimitFromHead) continue;

    if (!isLegalMoveWithPrimeCheck(boardState, pos, die, playerColor)) continue;

    const nextBoard = deepCopyBoard(boardState);
    const toPos     = pos + die;
    if (toPos >= pathToUse.length) {
      nextBoard[fromIdx].pop(); // bear-off
    } else {
      const toIdx = pathToUse[toPos] - 1;
      nextBoard[toIdx].push(nextBoard[fromIdx].pop());
    }

    bestResult = Math.max(
      bestResult,
      1 + dfs(nextBoard, restDice, headMoved + (isHead ? 1 : 0))
    );

    if (bestResult === diceArray.length) return bestResult; // максимум достигнут
  }

  return bestResult;
}
// ──────────────────────────────────────────────────────────────────










  const isDouble = diceArray[0] === diceArray[1];
  /* ===== Ограничение бросков с головы ===== */
const headBoardIndex    = playerColor === 'white' ? 23 : 11;   // индекс головы
const headCountBefore   = board[headBoardIndex].length;        // сколько шашек было в начале хода
const headLimitFromHead = maxHeadCheckers(headCountBefore, diceArray);
/* ======================================== */

  const dice = isDouble ? [diceArray[0], diceArray[0], diceArray[0], diceArray[0]] : diceArray;
  const path = playerColor === 'white' ? whiteLongPath : blackLongPath;
  const headIndex = playerColor === 'white' ? 23 : 11;
  const isWhite = playerColor === 'white';



 
  function chainMoves(posIndex, availableDice, depth = 0, boardState = board) {
  if (availableDice.length === 0) return 0;
  let max = 0;
  for (let i = 0; i < availableDice.length; i++) {
    const die = availableDice[i];
    const newPos = posIndex + die;




    /* ➊  ДОБАВЛЯЕМ обработку вывода  ---------------------------------- */
    if (newPos >= path.length) {                     // “за доской” ⇒ попытка bear-off
      const pointIdx = path[posIndex] - 1;           // реальный индекс 0-23
      if (canBearOff(boardState, playerColor, pointIdx, die)) {
        /* – симулируем снятие, чтобы следующий кубик видел новую доску */
        const tmp = deepCopyBoard(boardState);
        tmp[pointIdx].pop();
        const restDice = availableDice.filter((_, k) => k !== i);
        const sub = chainMoves(posIndex, restDice, depth + 1, tmp);  // ⚠️ posIndex НЕ меняется
        max = Math.max(max, 1 + sub);
      }
      continue;
    }



    if (newPos >= path.length) continue;
    if (!isLegalMoveWithPrimeCheck(boardState, posIndex, die, playerColor)) continue;

    // const restDice = [...availableDice];
    // restDice.splice(i, 1);
    // const subMoves = 1 + chainMoves(newPos, restDice, depth + 1, boardState);
        /* ➊  симулируем реальный ход, чтобы следующее проверяло уже новую доску */
    const tmp = deepCopyBoard(boardState);
    const fromIdx = path[posIndex] - 1;
    const toIdx   = path[newPos]   - 1;
    const checker = tmp[fromIdx].pop();
    tmp[toIdx].push(checker);

    const restDice = availableDice.filter((_, k) => k !== i);
    const subMoves = 1 + chainMoves(newPos, restDice, depth + 1, tmp);

    max = Math.max(max, subMoves);
  }
  return max;
}







  let totalMoves = 0;




  if (!isDouble) {
  const order1 = diceArray;
  const order2 = [...diceArray].reverse();

  totalMoves = Math.max(
    dfs(board, order1),
    dfs(board, order2)
  );
} else {
  totalMoves = dfs(board, dice, 0);
}




// }

/* ───── [SAFETY‑CHECK] ни один кубик не даёт легального хода? → 0 ───── */
if (totalMoves > 0) {                    // расчёт выше дал ≥1 хода
  const pathToUse = playerColor === 'white' ? whiteLongPath : blackLongPath;
  let atLeastOne = false;

  outer:                                      // метка для быстрого выхода
  for (let pos = 0; pos < pathToUse.length; pos++) {
    const boardIdx = pathToUse[pos] - 1;
    if (!board[boardIdx].length ||
        board[boardIdx][0].color !== playerColor) { continue; }

    for (const die of diceArray) {
      if (isLegalMoveWithPrimeCheck(board, pos, die, playerColor)) {
        atLeastOne = true;                   // нашли реальный ход
        break outer;
      }
    }
  }

  if (!atLeastOne) totalMoves = 0;           // «фантомные» ходы обнуляем
}
/* ───────────────────────────────────────────────────────────────────── */

  return totalMoves;
}



function isMovePossible(board, path, pos, die, color) {
  const targetPos = pos + die;
  if (targetPos >= path.length) return allCheckersInHome(board, color);

  const targetBoardIndex = path[targetPos] - 1;
  if (targetBoardIndex < 0 || targetBoardIndex >= 24) return false;

  const stack = board[targetBoardIndex];
  if (stack.length > 0 && stack[0].color !== color) return false;

  // Для черных: запрет выхода из дома
  if (color === 'black') {
    const currentVisual = path[pos];
    if (currentVisual >= 13 && currentVisual <= 18 && path[targetPos] < 13) return false;
  }

  return true;
}






  useEffect(() => {
     console.log('[DEBUG] useEffect joinLongTable запустился');
    const storedUser = localStorage.getItem('username') || '';
    if (!storedUser || !tableId) {
      setLongLoading('Нет username или tableId');
      setLongLoading(false);
      return;
    }
    setUsername(storedUser);

    // Подключаем socket, если не подключён
    if (!bigTournamentLongSocket.connected) {
      bigTournamentLongSocket.connect();
    }

   
if (!alreadyJoinedRef.current) {
  alreadyJoinedRef.current = true;
  console.log('[CLIENT] joinLongTable (из первого useEffect)');
  safeEmit('joinLongTable', {
    longTableId: parseInt(tableId, 10),
    playerUsername: storedUser,
  });
}




   



    // ===== 1) Игра: первый ответ 'longGameUpdated' =====
    function handleGameUpdated(game) {
    
      setLongLoading(false);
      setBlockStol(false)
      setLongPlayer1Name(game.player1_name || '');
      setLongPlayer2Name(game.player2_name || '');
      if (typeof game.player1_time_left === 'number') {
      setPlayer1Time(game.player1_time_left);
      }
      if (typeof game.player2_time_left === 'number') {
        setPlayer2Time(game.player2_time_left);
      }
      // Определяем свой цвет: если я player1 -> white, иначе black
      const isMePlayer1 = (game.player1_name === storedUser);
      setLongMyColor(isMePlayer1 ? 'white' : 'black');
console.log('[COLOR] myColor has been resolved to',
            isMePlayer1 ? 'white' : 'black');

      

 // Парсим board_state (из БД это строка)
 let parsedBoard = [];
try {
    parsedBoard = typeof game.board_state === "string" 
        ? JSON.parse(game.board_state) 
        : game.board_state;  // Если уже объект, просто используем его
        console.log('[LOG] handleGameUpdated → board_state =', parsedBoard);

} catch (e) {
    console.error('Ошибка при парсинге board_state:', e, game.board_state);
    parsedBoard = Array(24).fill([]);
}




const me = localStorage.getItem('username') || '';
 const myColorNow = detectMyColor(game, me);
 if (myColorNow) {
   setLongMyColor(myColorNow);
   setLongOpponentColor(myColorNow === 'white' ? 'black' : 'white');
 }

setLongBoardState(parsedBoard);

// off_board
if (game.off_board) {
    try {
        const offObj = typeof game.off_board === "string"
            ? JSON.parse(game.off_board)
            : game.off_board; // Проверка на объект

        setLongWhiteOffBoard(offObj.white || []);
        setLongBlackOffBoard(offObj.black || []);
    } catch (e) {
        console.error('[Long] parse off_board error:', e, game.off_board);
    }
}

      // Текущий ход, кубики
      setLongCurrentTurn(game.current_turn);
      // Если у вас player1_rolls/player2_rolls — вынимайте отсюда
      // здесь game.diceValues условно
      // setDiceValues(game.diceValues || []);
      // setNumberMove(game.numberMove || 0);
      // Примерно так, в зависимости от вашей БД
    }



    
    // ===== 2) boardUpdated (когда кто-то обновил доску) =====
    function handleBoardUpdated(payload) {
      const { longTableId, boardState, whiteOffBoard, blackOffBoard, longNumberMove } = payload;
     
      // if (String(longTableId) !== String(tableId)) return;
    

      if (boardState) setLongBoardState(boardState);
      if (whiteOffBoard) setLongWhiteOffBoard(whiteOffBoard);
      if (blackOffBoard) setLongBlackOffBoard(blackOffBoard);
      if (typeof longNumberMove === 'number') setLongNumberMove(longNumberMove);
    }

 
    function handleMoveUndone(data) {
  const {
    longTableId,
    newBoardState,
    longWhiteOffBoard,
    longBlackOffBoard,
    longNumberMove
  } = data;

  if (String(longTableId) !== String(tableId)) return;

  if (Array.isArray(newBoardState)) {
    setLongBoardState(newBoardState);
  }

  if (Array.isArray(longWhiteOffBoard)) {
    setLongWhiteOffBoard(longWhiteOffBoard);
  }

  if (Array.isArray(longBlackOffBoard)) {
    setLongBlackOffBoard(longBlackOffBoard);
  }

  if (typeof longNumberMove === 'number') {
    setLongNumberMove(longNumberMove);
  }

  // ВАЖНО:
  // историю здесь НЕ уменьшаем.
  // Игрок, который нажал Undo, уже удалил одну запись
  // внутри undoLastMove().
}
    // ===== 4) moveUndone (когда кто-то отменил ход) =====
    // function handleMoveUndone(data) {
    //   const { longTableId, newBoardState,  longWhiteOffBoard, longBlackOffBoard, longNumberMove } = data;
    //   if (String(longTableId) !== String(tableId)) return;
    //   // console.log('[Long] moveUndone =>', data);

    //   if (newBoardState) setLongBoardState(newBoardState);
    //   if (longWhiteOffBoard) setLongWhiteOffBoard(longWhiteOffBoard);
    //   if (longBlackOffBoard) setLongBlackOffBoard(longBlackOffBoard);
    //   if (typeof longNumberMove === 'number') setLongNumberMove(longNumberMove);

    //   // Локально убираем последний ход из истории (если нужно)
    //   setLongMoveHistory((prev) => prev.slice(0, -1));
    // }

    // Подписываемся
    bigTournamentLongSocket.on('longGameUpdated', handleGameUpdated);
    bigTournamentLongSocket.on('longGame_boardUpdated', handleBoardUpdated);
    // bigTournamentLongSocket.on('longGame_diceRolled', handleDiceRolled);
    bigTournamentLongSocket.on('longGame_moveUndone', handleMoveUndone);

    return () => {
      bigTournamentLongSocket.off('longGameUpdated', handleGameUpdated);
      bigTournamentLongSocket.off('longGame_boardUpdated', handleBoardUpdated);
      // bigTournamentLongSocket.off('longGame_diceRolled', handleDiceRolled);
      bigTournamentLongSocket.off('longGame_moveUndone', handleMoveUndone);
    };
  }, [tableId]);

 




  useEffect(() => {
    function handleDiceRolled(data) {
  /* 0. Не наш стол — игнорируем */
  if (data.longTableId !== Number(tableId)) return;

  /* 1. Определяем цвет и чья очередь */
  const me       = localStorage.getItem('username') || '';
  const myColor  = (data.player1_name === me) ? 'white' : 'black';
  const isMyTurn =
    (myColor === 'white' && data.currentPlayer === 'player1') ||
    (myColor === 'black' && data.currentPlayer === 'player2');

  /* 2. Достаём последнее значение кубиков того, кто ходит сейчас */
  const lastRoll = data.currentPlayer === 'player1'
    ? (data.player1_rolls.at(-1) || [])
    : (data.player2_rolls.at(-1) || []);

  if (lastRoll.length < 2) {
    console.warn('[handleDiceRolled] некорректный lastRoll:', lastRoll);
    return;
  }

  const [d1, d2] = lastRoll;
  const dice     = (d1 === d2) ? [d1, d1, d1, d1] : [d1, d2];

  /* 3. Всем показываем выпавшие кубики (визуал) */
  setLongRolledDice(lastRoll);

  /* 4. Если ход оппонента — просто фиксируем server‑side счётчик и выходим */
  if (!isMyTurn) {
    setLongNumberMove(data.numberMove ?? 0);
    return;
  }

  /* 5. Мой ход — считаем, сколько реально можно сходить */
  setLongDiceValues(dice);
  setLongHasRolledDice(true);

  const usableCount = calculateUsableDice(longBoardState, myColor, dice);

  /* ─── 5‑а. Ходов нет  ─────────────────────────────── */
  if (usableCount === 0) {
    setLongDiceValues([]); 
    setLongNumberMove(0);                      // локальный счётчик → 0
    setLongHasRolledDice(true);
    /* сообщаем серверу, что ходов ноль (UI покажет кнопку «Завершить ход») */
    safeEmit('long_updateNumberMove', {
      longTableId   : Number(tableId),
      currentPlayer : data.currentPlayer,
      longNumberMove: 0
    });

    /* НЕ вызываем longConfirmMove – игрок подтвердит вручную */
    return;
  }

  /* ─── 5‑б. Есть ≥1 ход  ───────────────────────────── */
  setLongNumberMove(usableCount);

  safeEmit('long_updateNumberMove', {
    longTableId   : Number(tableId),
    currentPlayer : data.currentPlayer,
    longNumberMove: usableCount
  });
}


    bigTournamentLongSocket.on("longGame_diceRolled", handleDiceRolled);
    return () => {
      bigTournamentLongSocket.off("longGame_diceRolled", handleDiceRolled);
    };
  }, [tableId, longBoardState, headMoveCount]);
  
  
  










  const handleLongRollDiceClick = () => {
      if (!isSocketConnected || isFinished) return;

    // const isMyTurn =
    //   (longPlayerColor === 'white' && longCurrentTurn === 'player1') ||
    //   (longPlayerColor === 'black' && longCurrentTurn === 'player2');
      setLongHasRolledDice(false); 
      // setRolledDice
      setLongRollEnabled(false);
      setLongInitialRollPhase(true); // Добавьте эту строку
    // console.log('[emit] ShortBackgammon_rollDice =>', {
    //   longTableId: parseInt(tableId, 10),
    //   currentPlayer: longCurrentTurn
    // });
  
    // if (isMyTurn && !longHasRolledDice) {
      safeEmit('longGame_rollDice', {
        longTableId: parseInt(tableId, 10),
        currentPlayer: longCurrentTurn
      });
    
    // }
 
  };


 


  // const whitePath = [24,23,22,21,20,19,18,17,16,15,14,13, 12,11,10,9,8,7, 6,5,4,3,2,1];
  // const blackPath = [12,11,10,9,8,7,6,5,4,3,2,1, 24,23,22,21,20,19, 18,17,16,15,14,13];

  const whiteLongPath = [
    24, 23, 22, 21, 20, 19, 18,
    17, 16, 15, 14, 13,
    12, 11, 10, 9, 8, 7,
     6, 5, 4, 3, 2, 1
  ];
  
  const blackLongPath = [
    12, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1,
    24, 23, 22, 21, 20, 19,
    18, 17, 16, 15, 14, 13
  ];

  
// Конвертация индекса, который приходит от UI в реальный индекс доски
const visualIndexToRealIndex = (uiIndex) => {
  if (uiIndex >= 0 && uiIndex <= 11) {
    return 11 - uiIndex; // нижний ряд (визуально: 12 → 1)
  } else if (uiIndex >= 12 && uiIndex <= 23) {
    return 35 - uiIndex; // верхний ряд (визуально: 13 → 24)
  }
}; 
// const visualIndexToRealIndex = (uiIndex) => 23 - uiIndex;
const indexToVisualNumber = (index) => index + 1;






const longOnPointClick = (uiIndex) => {

   // нет соединения или партия уже закончена — ничего не делаем
  if (!isSocketConnected || isFinished) return;

    if (!isMyTurn) return;        // <‑‑ защита};

if (!longHasRolledDice || longDiceValues.length === 0) {
  return; // ❌ нельзя ходить, если кубики не брошены
}

  // Преобразуем визуальный индекс в реальный (0–23)
  const index = visualIndexToRealIndex(uiIndex);
  const visualNumber = indexToVisualNumber(index);



  if (!longDiceValues.length || longNumberMove <= 0) {

    return;
  }

  const newBoard = deepCopyBoard(longBoardState);
  /* ---------- SOURCE-CHECK ------------------------------------ */
if (
  !newBoard[index]?.length ||                                   // пусто
  newBoard[index][newBoard[index].length - 1].color !== longMyColor
) {
 
  return;                                                       // прерываем обработчик
}
/* ------------------------------------------------------------- */

  const isWhite = longMyColor === 'white';
  const isBlack = longMyColor === 'black';
  // Для белых голова – визуально 24 (индекс 23), для чёрных – визуально 12 (индекс 11)
  const whiteHeadIndex = 23;
  const blackHeadIndex = 11;
  const isFromHead = (isWhite && index === whiteHeadIndex) ||
                     (isBlack && index === blackHeadIndex);
// Определяем originalDice один раз, чтобы дальше везде было доступно:
const originalDice = longDiceValues.length > 2
  ? [longDiceValues[0], longDiceValues[1]]
  : [...longDiceValues];

  // Проверяем ограничения для хода с головы
  let isFullHead = false;
  let isDouble = false;
  if (isFromHead) {


    // Если это первый ход с головы в текущем раунде, фиксируем изначальное количество шашек
    if (headInitialCountRef.current === null) {
      headInitialCountRef.current = newBoard[index].length;
    }
  
const allowed = maxHeadCheckers(
      headInitialCountRef.current,
      originalDice
    );
    if (headCheckersMoved >= allowed) {
      return;              // стоп: лимит снятых шашек исчерпан
    }

 
  

  }

  // Сохраняем состояние для undo
  const prevNumberMove = longNumberMove;
  const prevDiceValues = [...longDiceValues];
  const boardBefore = deepCopyBoard(longBoardState);
/* ---------- B E A R  O F F ------------- */
{
  // сортируем кубики от большего к меньшему — так требует правило
  const dieForBear = [...longDiceValues]
                       .sort((a, b) => b - a)
                       .find(d => canBearOff(longBoardState, longMyColor, index, d));

  if (dieForBear !== undefined) {
    // можно вынести шашку — делаем это и завершаем обработчик
    performBearOff(index, dieForBear);
    return;
  }
}
/* --------------------------------------- */

  // Подготавливаем оставшиеся кубики (если дубль – расширяем массив)
  let remainingDice = [...longDiceValues];
  if (remainingDice.length === 2 && remainingDice[0] === remainingDice[1]) {
    remainingDice = [remainingDice[0], remainingDice[0], remainingDice[0], remainingDice[0]];
  }
  remainingDice.sort((a, b) => b - a);
  const direction = -1; 
  

const wrap = (idx) => {
  if (longMyColor === 'white' && idx < 0)  return idx + 24;
  if (longMyColor === 'black' && idx > 23) return idx - 24;
  return idx;
};

  let chosenDie = null;
  let targetIndex = -1;
  let foundMove = false;

  console.log('[DEBUG] Мой цвет:', longMyColor);
console.log('[DEBUG] Текущий индекс (index):', index);
console.log('[DEBUG] Доступные кубики:', remainingDice);

for (let dieVal of remainingDice) {
    let tempTarget = index + dieVal * direction;
    if (longMyColor === 'black' && tempTarget < 0) {
      tempTarget = 24 + tempTarget;
    }
    if (tempTarget < 0 || tempTarget > 23) continue;
    if (longMyColor === 'black') {
      const currentPoint = index + 1;
      const targetPoint = tempTarget + 1;
      if (currentPoint >= 13 && currentPoint <= 18 && targetPoint < 13) continue;
    }
    const stackAtTarget = newBoard[tempTarget];
    if (stackAtTarget.length > 0 && stackAtTarget[0].color !== longMyColor) continue;
    chosenDie = dieVal;
    targetIndex = tempTarget;
    foundMove = true;
    break;
  }



  if (!foundMove) {

    return;
  }

  // Выполняем ход: перемещаем шашку с пункта index в пункт targetIndex
  if (newBoard[index]?.length) {
    const topChecker = newBoard[index][newBoard[index].length - 1];
    if (topChecker.color === longMyColor) {
      newBoard[index].pop();
      newBoard[targetIndex].push(topChecker);
      if (violatesPrimeRule(newBoard, longMyColor)) {
 
        return;
      }
      setLongMoveHistory((prev) => [
        ...prev,
        {
          from: index,
          to: targetIndex,
          boardBefore,
          diceUsed: [chosenDie],
          prevNumberMove,
          prevDiceValues,
        },
      ]);

      // Если ход с головы – увеличиваем headMoveCount
      let localHeadMoveCount = headMoveCount;
      if (isFromHead) {
      localHeadMoveCount++;
    setHeadMoveCount(localHeadMoveCount);
    setHeadCheckersMoved(c => c + 1);
      }

      // Если ход с головы с допустимым дублем (то есть изначально было ровно 15 шашек),
      // то оставшееся число ходов должно быть 2 минус число уже совершённых ходов.
      
      if (isFromHead && isFullHead && isDouble) {
        const dieVal = originalDice[0];
        let maxMovesFromHead = 1;
        if (dieVal === 3 || dieVal === 4) {
          maxMovesFromHead = 4;
        } else if (dieVal === 6) {
          maxMovesFromHead = 2;
        }
      
        const newNumberMove = maxMovesFromHead - localHeadMoveCount;
        setLongNumberMove(newNumberMove);
      
console.log('[SEND] longGame_updateBoardState { ephemeral: true }');

       emitBoardUpdate({
  longTableId: parseInt(tableId, 10),
  boardState: newBoard,
  longWhiteOffBoard,
  longBlackOffBoard,
  longNumberMove: longNumberMove - 1
});


        awaitingConfirmRef.current = true;
console.log('[SEND] longGame_updateBoardState { ephemeral: true }');

      } else {
        setLongNumberMove(prev => prev - 1);
       emitBoardUpdate({
  longTableId: parseInt(tableId, 10),
  boardState: newBoard,
  longWhiteOffBoard,
  longBlackOffBoard,
  longNumberMove: longNumberMove - 1
});


        awaitingConfirmRef.current = true;

      }

      // Удаляем использованный кубик из longDiceValues
      const newDiceValues = [...longDiceValues];
      const dieIndex = newDiceValues.indexOf(chosenDie);
      if (dieIndex > -1) {
        newDiceValues.splice(dieIndex, 1);
      }
      setLongDiceValues(newDiceValues);
      setLongBoardState(newBoard);

     
    } else {
    
    }
  } else {
   
  }
  setLongLastMoveType('click');
};
















function checkAvailableMoves(board, playerColor, diceArray) {
  const availableMoves = [];
  // Перебираем все точки на доске
  for (let pos = 0; pos < board.length; pos++) {
    // Если в точке есть шашка нужного цвета
    if (board[pos].length > 0 && board[pos][0].color === playerColor) {
      diceArray.forEach(die => {
        const targetPos = calculateTarget(pos, die, playerColor);
        if (targetPos !== null && isMoveAllowed(board, pos, targetPos, playerColor)) {
          // Логируем конкретный ход: с какого пункта на какой, используя какой кубик
       
          availableMoves.push({ from: pos, to: targetPos, die });
        }
      });
    }
  }
  // Лог общего количества найденных ходов
 
  return availableMoves;
}
 
// Пример функции, вычисляющей целевую позицию (с учетом направления, wrap-around и ограничений)
function calculateTarget(from, die, playerColor) {
  const direction = (playerColor === 'white') ? -1 : 1;
  let target = from + die * direction;
  // Если позиция выходит за границы – вернуть null (или обработать wrap-around для определённых ситуаций)
  if (target < 0 || target > 23) return null;
  return target;
}

// Пример функции, проверяющей, можно ли походить из from в target (учитывая блокировки и домашнюю зону)
function isMoveAllowed(board, from, target, playerColor) {
  // Если целевая точка пуста, или содержит шашки того же цвета – ход допустим.
  const targetStack = board[target];
  if (!targetStack || targetStack.length === 0) return true;
  if (targetStack[0].color === playerColor) return true;
  return false;
}



  // ==============================
  // Drag & Drop
  // ==============================
  const longHandleDragStart = (e, fromUIIndex, checkerIndex) => {
   
    const dragData = { fromUIIndex, checkerIndex };
    e.dataTransfer.setData('text/plain', JSON.stringify(dragData));
    
  };

  const longHandleDragOver = (e) => {
    e.preventDefault(); // разрешаем drop
  
  };








function hasLegalMoveForDie(board, die, playerColor) {
  const path = playerColor === 'white' ? whiteLongPath : blackLongPath;

  for (let pos = 0; pos < path.length; pos++) {
    const boardIdx = path[pos] - 1;
    if (!board[boardIdx].length) continue;
    if (board[boardIdx][0].color !== playerColor) continue;

    if (isLegalMoveWithPrimeCheck(board, pos, die, playerColor))
      return true;                       // ← нашли ход → true
  }
  return false;
}








  const longHandleDrop = (e, dropUIIndex) => {
    if (!isSocketConnected || isFinished) return;
    if (!isMyTurn) return;        // <‑‑ защита

if (!longHasRolledDice || longDiceValues.length === 0) {
  return; // ❌ нельзя ходить, если кубики не брошены
}


    e.preventDefault();
   
  // dropUIIndex уже является реальным индексом (realIndex), не нужно его преобразовывать ещё раз!
  if (!longDiceValues?.length || longNumberMove <= 0) {
  
    return;
  }
 
  const rawData = e.dataTransfer.getData('text/plain');
  if (!rawData) {

  return;}

  const { fromUIIndex, checkerIndex } = JSON.parse(rawData);
 
// 🔁 Преобразуем визуальные индексы в "белую" ориентацию для чёрных
// Преобразование UI-индексов для чёрных (если они в перевёрнутом виде)









const mapUIIndexForColor = (uiIndex) => {
  if (longMyColor === 'black') {
    // UI индексы 0..11 => bottom row => реальные 12..23
    // UI индексы 12..23 => top row => реальные 11..0
    if (uiIndex <= 11) return 12 + uiIndex;
    else return 35 - uiIndex;
  }
  return uiIndex; // для белых — без изменений
};


// 🔁 Преобразуем UI индексы в реальные индексы, как при клике:
const fromIndex = visualIndexToRealIndex(fromUIIndex);
const toIndex = visualIndexToRealIndex(dropUIIndex);

const path = longMyColor === 'white' ? whiteLongPath : blackLongPath;
const createBoardIndexToPathIndex = (path) => {
  const map = {};
  path.forEach((point, i) => {
    map[point - 1] = i;
  });
  return map;
};
const boardIndexToPathPos = createBoardIndexToPathIndex(path);
const fromPos = boardIndexToPathPos[fromIndex];
const toPos = boardIndexToPathPos[toIndex];

if (
  longNumberMove === 1 &&
  longDiceValues.length === 2 &&
  longDiceValues[0] !== longDiceValues[1]
) {
  const [bigDie, smallDie] = [...longDiceValues].sort((a, b) => b - a);

  const dieUserAsked = Math.abs(toPos - fromPos);

  if (
    dieUserAsked === smallDie &&
    hasLegalMoveForDie(longBoardState, bigDie, longMyColor)
  ) {
    console.warn('[PRIORITY BLOCKED] Меньший кубик заблокирован');
    return;
  }

     // 1 … 6

  /* если пользователь выбрал меньший кубик, а больший можно сыграть – отклоняем drop */
  if (
    dieUserAsked === smallDie &&          // тащит маленький…
    hasLegalMoveForDie(longBoardState, bigDie, longMyColor) // …а  большой реально играется
  ) {
    // 👉  просто прерываем обработчик; визуально фишка «отпружинит» назад
    return;
  }
}

  if (fromIndex < 0 || fromIndex > 23 || toIndex < 0 || toIndex > 23) {

    return;
  }
    // 4) Копируем доску
    const newBoard = deepCopyBoard(longBoardState);
  
    // 5) Проверяем, есть ли вообще шашка нашего цвета в точке fromIndex
    if (!newBoard[fromIndex] || newBoard[fromIndex].length === 0) {

      return;
    }



    const whiteHeadIndex = 23;
    const blackHeadIndex = 11;
    const isFromHead1 = (longMyColor === 'white' && fromIndex === whiteHeadIndex) ||
                       (longMyColor === 'black' && fromIndex === blackHeadIndex);
    
    // --- Проверка хода с головы (drag & drop) ---
    if (isFromHead1) {

    
      if (headInitialCountRef.current === null) {
        headInitialCountRef.current = newBoard[fromIndex].length;
      }
      const initialHeadCount = headInitialCountRef.current;
      const isFullHead = (initialHeadCount === 15);
    
      const originalDice = longDiceValues.length > 2 
        ? [longDiceValues[0], longDiceValues[1]]
        : [...longDiceValues];
    
      const validDouble = [3, 4, 6].includes(originalDice[0]);
      const isDouble = (
        originalDice.length === 2 &&
        originalDice[0] === originalDice[1] &&
        isFullHead &&
        validDouble
      );
    
   

 const allowed = maxHeadCheckers(
   headInitialCountRef.current,
   originalDice
 );
 if (headCheckersMoved >= allowed) return;
    }
    
    // ... дальше по коду, где не нужно повторно вычислять isFromHead ...
    





    const topChecker = newBoard[fromIndex][newBoard[fromIndex].length - 1];


    if (topChecker.color !== longMyColor) {

      return;
    }
  
    // 6) Аналог проверки «ход с головы» (как в onPointClick)
    const isWhite = (longMyColor === 'white');
    const headIndex = isWhite ? 23 : 11;
    const isFromHead = (fromIndex === headIndex);
  
    let isFullHead = false;
    let isDouble   = false;
  
    // Если снимаем с головы, проверяем, была ли там изначально 15
    if (isFromHead) {
      if (headInitialCountRef.current === null) {
        headInitialCountRef.current = newBoard[fromIndex].length;
      }
      const initialCount = headInitialCountRef.current;
      isFullHead = (initialCount === 15);
  
      // Проверяем дубль для головы (3,3), (4,4) или (6,6) и т.д. (зависит от вашей логики)
      const originalDice = (longDiceValues.length > 2)
        ? [longDiceValues[0], longDiceValues[1]]
        : [...longDiceValues];
      const validDouble = [3, 4, 6].includes(originalDice[0]);
      isDouble = (
        originalDice.length === 2 &&
        originalDice[0] === originalDice[1] &&
        isFullHead &&
        validDouble
      );
    }
  



    // 7) Расширяем массив кубиков, если дубль, и сортируем
    let remainingDice = [...longDiceValues];
    if (remainingDice.length === 2 && remainingDice[0] === remainingDice[1]) {
      remainingDice = [remainingDice[0], remainingDice[0], remainingDice[0], remainingDice[0]];
    }
    remainingDice.sort((a, b) => b - a);
  
    // 8) Смотрим, какой кубик «подходит» чтобы из fromIndex попасть в toIndex
    //    (точно так же, как вы делаете в onPointClick)
    // const direction = isWhite ? -1 : 1;
    const direction = -1;
    let chosenDie = null;
    let foundMove = false;
  
    // Здесь wrap-around для чёрных
    for (let dieVal of remainingDice) {
      let tempTarget = fromIndex + dieVal * direction;
      if (!isWhite && tempTarget < 0) {
        tempTarget += 24; // wrap, если нужно
      }
   
      if (tempTarget === toIndex) {
        // Пробуем переместить, проверяем «правило прайма»
        newBoard[fromIndex].pop();
        newBoard[toIndex].push(topChecker);
  
        if (violatesPrimeRule(newBoard, longMyColor)) {
        
          return;
        }
  
        // Проверка «домашнего» ограничения для чёрных (например, нельзя выйти из 13..18 в <13)
        if (!isWhite) {
          const currentPoint = fromIndex + 1;
          const targetPoint  = toIndex   + 1;
          if (currentPoint >= 13 && currentPoint <= 18 && targetPoint < 13) {
          
            return;
          }
        }
  





        chosenDie = dieVal;
        foundMove = true;
        break;
      }
    }
  
    if (!foundMove) {
      // Попытка пройти в пункт суммой двух разных кубиков (в любом порядке)
  const need = toPos - fromPos;
  if (
    longDiceValues.length >= 2 &&
    longDiceValues[0] !== longDiceValues[1] &&
    longDiceValues[0] + longDiceValues[1] === need
  ) {
    const path = longMyColor === 'white' ? whiteLongPath : blackLongPath;
    const orders = [
      [longDiceValues[0], longDiceValues[1]],
      [longDiceValues[1], longDiceValues[0]],
    ];

    for (const seq of orders) {
      // симуляция пошагово
      let tmpBoard = deepCopyBoard(longBoardState);
      let p = fromPos;
      let ok = true;
      const chain = [];

      for (const d of seq) {
        if (!isLegalMoveWithPrimeCheck(tmpBoard, p, d, longMyColor)) { ok=false; break; }
        const fromIdxSim = path[p] - 1;
        const pNext      = p + d;
        const toIdxSim   = path[pNext] - 1;

        const ch = tmpBoard[fromIdxSim].pop();
        tmpBoard[toIdxSim].push(ch);

        if (violatesPrimeRule(tmpBoard, longMyColor)) { ok=false; break; }
        chain.push({ from: fromIdxSim, to: toIdxSim, die: d });
        p = pNext;
      }

      if (ok) {
        // история/undo
        const boardBefore    = deepCopyBoard(longBoardState);
        const prevNumberMove = longNumberMove;
        const prevDiceValues = [...longDiceValues];

        // убрать использованные два кубика
        const nextDice = (() => {
          const arr = [...longDiceValues];
          for (const d of seq) {
            const i = arr.indexOf(d);
            if (i > -1) arr.splice(i, 1);
          }
          return arr;
        })();

        setLongMoveHistory(prev => [...prev, {
          type: 'drag',
          from: chain[0].from,
          to  : chain[chain.length - 1].to,
          chain,
          diceUsed: seq,
          boardBefore,
          prevNumberMove,
          prevDiceValues
        }]);

        setLongBoardState(tmpBoard);
        setLongDiceValues(nextDice);
        setLongNumberMove(n => n - seq.length);
        setLongLastMoveType('drag');

        emitBoardUpdate({
          longTableId: parseInt(tableId, 10),
          boardState : tmpBoard,
          longWhiteOffBoard,
          longBlackOffBoard,
          longNumberMove: longNumberMove - seq.length
        });
        awaitingConfirmRef.current = true;
        return; // удачно сходили суммой — выходим
      }
    }
  }

      return;
    }
  
    // 9) Сохраняем состояние для Undo (копию доски ДО хода)
    const boardBefore = deepCopyBoard(longBoardState);
    const prevNumberMove = longNumberMove;
    const prevDiceValues = [...longDiceValues];
  
    // Так как мы «поп» делали в проверке, лучше сделаем окончательно заново, 
    // чтобы не ломать массив, если нарушится прайм. Идём по тому же пути, что и onPointClick:
    const finalBoard = deepCopyBoard(longBoardState);
    finalBoard[fromIndex].pop();
    finalBoard[toIndex].push(topChecker);
  
    // Сохраняем шаг в историю
    setLongMoveHistory(prev => ([
      ...prev,
      {
        from: fromIndex,
        to:   toIndex,
        boardBefore,
        diceUsed: [chosenDie],
        prevNumberMove,
        prevDiceValues
      }
    ]));
  
    // 10) Если ход с головы — обновляем счётчик headMoveCount
    let localHeadCount = headMoveCount;
    if (isFromHead) {
      localHeadCount++;
      setHeadMoveCount(localHeadCount);
    }
  
    // 11) Считаем новое число ходов
    let newNumberMove;
    if (isFromHead && isFullHead && isDouble) {
      // Ваша логика, как в onPointClick (например, 3/4 -> 4 хода, 6 -> 2 и т.п.)
      const val = prevDiceValues[0];
      if (val === 3 || val === 4) {
        newNumberMove = 4 - localHeadCount;
      } else if (val === 6) {
        newNumberMove = 2 - localHeadCount;
      } else {
        // или просто min(0, longNumberMove - 1), если у вас другая логика
        newNumberMove = longNumberMove - 1;
      }
    } else {
      newNumberMove = longNumberMove - 1;
    }
  
    // 12) Убираем кубик chosenDie
    const newDiceArr = [...longDiceValues];
    const idx = newDiceArr.indexOf(chosenDie);
    if (idx >= 0) {
      newDiceArr.splice(idx, 1);
    }
  
    // 13) Обновляем стейты
    setLongBoardState(finalBoard);
    setLongDiceValues(newDiceArr);
    setLongNumberMove(newNumberMove);
    setLongLastMoveType('drag'); // Чтобы отличать этот ход от клика (для undo)
  




    // 14) Отправляем обновление на сервер
    emitBoardUpdate({
  longTableId: parseInt(tableId, 10),
  boardState: newBoard,
  longWhiteOffBoard,
  longBlackOffBoard,
  longNumberMove: longNumberMove - 1
});


  awaitingConfirmRef.current = true;

  };






const longHandleUndoMove          = () => undoLastMove();
const longHandleUndoMoveForClick  = undoLastMove;   // если где-то ещё используется
const longHandleUndoMoveForDrag   = undoLastMove;







  useEffect(() => {
  if (!isMyTurn || longMoveHistory.length === 0) {
    setLongShowUndoButton(false);
  } else {
    setLongShowUndoButton(true);
  }
}, [isMyTurn, longMoveHistory]);

const onResign = useCallback(() => {
   if (!tableId || isFinished) return;
   const ok = window.confirm(translate('jackpotBoard.resignConfirmLong'));
   if (!ok) return;
   setResignPending(true);
   safeEmit('long_resign', { longTableId: Number(tableId) });
 }, [tableId, isFinished, translate]);

  // ==============================
  // Рендер
  // ==============================
  if (longLoading) {
    return <div>{translate('jackpotBoard.loadingLong')}</div>;
  }
  if (longError) {
    return <div style={{ color: 'red' }}>{longError}</div>;
  }

  // Определяем, мой ли это ход, чтобы показать кнопку "Бросить кубики"
  const iAmWhite = (longMyColor === 'white');
  // const isMyTurn = (
  //   (iAmWhite && longCurrentTurn === 'player1') ||
  //   (!iAmWhite && longCurrentTurn === 'player2')
  // );

  return (
    <div className="btl-page">
     {/* {longFirstRolls &&
 longFirstRolls.player1Roll !== null &&
 longFirstRolls.player2Roll !== null && (
  <div style={{ marginBottom: '10px', fontWeight: 'bold' }}>
    Первый бросок: &nbsp;
    Белые 🎲 {longFirstRolls.player1Roll} &nbsp;&nbsp;
    Чёрные 🎲 {longFirstRolls.player2Roll}
  </div>


)} */}



      {/* <h2>Long Backgammon Table #{tableId}</h2>  */}
      {/* <p>Player1: {longPlayer1Name} (White), Player2: {longPlayer2Name} (Black)</p> */}
      {/* <p>Мой цвет: {longMyColor}, Текущий ход: {longCurrentTurn}</p> */}
      {/* <p>Кубики: {longRolledDice.join(', ')} | Осталось ходов: {longNumberMove}</p>
{/* {longFirstRolls &&
 longFirstRolls.player1Roll !== null &&
 longFirstRolls.player2Roll !== null && (
  <div style={{ marginBottom: '10px', fontWeight: 'bold' }}>
    Первый бросок (ещё раз): &nbsp;
    Белые 🎲 {longFirstRolls.player1Roll} &nbsp;&nbsp;
    Чёрные 🎲 {longFirstRolls.player2Roll}
  </div>
)} */}
{/* {!longFirstMoveComplete && longFirstRolls &&
 longFirstRolls.player1Roll !== null &&
 longFirstRolls.player2Roll !== null && (
  <div style={{ marginBottom: '10px', fontWeight: 'bold' }}>
    Первый бросок: &nbsp;
    Белые 🎲 {longFirstRolls.player1Roll} &nbsp;&nbsp;
    Чёрные 🎲 {longFirstRolls.player2Roll}
  </div>
)} */}


      {/* Кнопка бросить кубики (если это мой ход и кубики не брошены) */}
      {/* {isMyTurn && longDiceValues.length === 0 && (
        <button onClick={handleRollDice}>Бросить кубики (Long)</button>
      )} */}

      {/* Кнопка отмены хода, если showUndoButton = true */}
      {/* {longShowUndoButton && (
        <button onClick={handleUndoMove}>Отменить ход</button>
      )} */}

      {/* Дочерний компонент отрисовки доски */}
      <BigTournamentBackgammonBoardDisplay   
        longBoardState={longBoardState}
        longWhiteOffBoard={longWhiteOffBoard}
        longBlackOffBoard={longBlackOffBoard}
        longDiceValues={longDiceValues} 
        longMyColor={longMyColor}
        longCurrentTurn={longCurrentTurn}
        longOnPointClick={longOnPointClick}
        longHandleDragStart={longHandleDragStart}
        longHandleDragOver={longHandleDragOver} // ✅
        longHandleDrop={longHandleDrop}
        longFirstRolls={longFirstRolls}
        longShowUndoButton = {longShowUndoButton}
        longHasRolledDice = {longHasRolledDice}
        longFirstMoveComplete = {longFirstMoveComplete}
        longNumberMove = {longNumberMove}
        longConfirmMove = {longConfirmMove}
        longHandleUndoMove = {longHandleUndoMove} 
        handleLongRollDiceClick= {handleLongRollDiceClick}
        longRolledDice = {longRolledDice}
        longMoveHistory = {longMoveHistory}
        longRollEnabled = {longRollEnabled}
        player1Time = {player1Time}
        player2Time = {player2Time}
        onResign={onResign}
        resignDisabled={isFinished || resignPending}
        player1Profile={player1Profile}
        player2Profile={player2Profile}
        longPlayer1Name={longPlayer1Name}
        longPlayer2Name={longPlayer2Name}
        tournamentStageLabel={tournamentStageLabel}
         tournamentPrize={tournamentPrize}
         autoRoll = {autoRoll}
         autoConfirm = {autoConfirm}
         onToggleAutoRoll = {onToggleAutoRoll}
         onToggleAutoConfirm = {onToggleAutoConfirm}
      />
      {endModal.open && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.68)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            padding: 16,
          }}
        >
          <div
            style={{
              width: 'min(92vw, 590px)',
              background: '#101317',
              color: 'white',
              borderRadius: '16px',
              padding: '26px 22px',
              textAlign: 'center',
              boxShadow: '0 10px 34px rgba(0,0,0,0.48)',
              border: endModal.rebuyAvailable
                ? '1px solid rgba(218,179,97,0.42)'
                : '1px solid rgba(255,255,255,0.08)'
            }}
          >
            <div
              style={{
                fontSize: 23,
                fontWeight: 800,
                marginBottom: 10,
              }}
            >
              {endModal.title}
            </div>

            <div
              style={{
                fontSize: 16,
                opacity: 0.9,
                marginBottom: 6,
                lineHeight: 1.45,
              }}
            >
              {endModal.subtitle}
            </div>

            {!!endModal.note && (
              <div
                style={{
                  fontSize: 13,
                  opacity: 0.72,
                  marginTop: 10,
                  lineHeight: 1.5,
                }}
              >
                {endModal.note}
              </div>
            )}

            {!!endModal.rebuyError && (
              <div
                style={{
                  marginTop: 13,
                  padding: '10px 12px',
                  borderRadius: 9,
                  background: 'rgba(220,70,70,0.10)',
                  border: '1px solid rgba(220,70,70,0.25)',
                  color: '#f0a0a0',
                  fontSize: 13,
                }}
              >
                {endModal.rebuyError}
              </div>
            )}

            {endModal.rebuyAvailable ? (
              <>
                <div
                  style={{
                    display: 'flex',
                    gap: 10,
                    justifyContent: 'center',
                    flexWrap: 'wrap',
                    marginTop: 20,
                  }}
                >
                  <button
                    type="button"
                    disabled={rebuyPending}
                    onClick={performImmediateRebuy}
                    style={{
                      border: 0,
                      borderRadius: 10,
                      padding: '12px 18px',
                      background: 'linear-gradient(180deg, #deb868, #b98533)',
                      color: '#15181d',
                      cursor: rebuyPending ? 'wait' : 'pointer',
                      fontWeight: 900,
                    }}
                  >
                    {rebuyPending
                      ? translate('jackpotBoard.rebuyWorking')
                      : translate('jackpotBoard.rebuyButton', { cost: Number(endModal.rebuyCost || 0) })}
                  </button>

                  <button
                    type="button"
                    disabled={rebuyPending}
                    onClick={chooseRebuyLater}
                    style={{
                      border: '1px solid rgba(255,255,255,0.12)',
                      borderRadius: 10,
                      padding: '12px 18px',
                      background: 'rgba(255,255,255,0.04)',
                      color: '#aeb4bd',
                      cursor: rebuyPending ? 'not-allowed' : 'pointer',
                      fontWeight: 800,
                    }}
                  >
                    {translate('jackpotBoard.laterLobby')}
                  </button>
                </div>

                <div
                  style={{
                    marginTop: 13,
                    fontSize: 12,
                    color: '#8d949e',
                    lineHeight: 1.45,
                  }}
                >
                  {translate('jackpotBoard.laterHintLong')}
                </div>
              </>
            ) : (
              <div
                style={{
                  marginTop: 18,
                  fontSize: 13,
                  opacity: 0.6,
                }}
              >
                {translate('jackpotBoard.redirectingLobby')}
              </div>
            )}
          </div>
        </div>
      )}

    </div>
  );
}
// Вспомогательная функция глубокого копирования доски
function deepCopyBoard(longBoard) {
  return longBoard.map(stack => stack.map(ch => ({ ...ch }))); 
}

export default BigTournamentBackgammon;

